<template>
  <div :class="[cardTable, { 'column-draggable': columnDraggable }, { 'column-resizable': columnResizable }]">
    <!-- border是显示竖线条 -->
    <el-table
      ref="refTable"
      :key="'table-' + tableRenderKey"
      :id="tableID ? tableID : ''"
      :height="computedHeight"
      max-height="100%"
      :data="tableData"
      :row-key="rowKey || undefined"
      @row-click="rowClick"
      v-loading="loading"
      :empty-text="loading ? ' ' : '暂无数据'"
       :row-class-name="rowClassName"
      @expand-change="expandChange"
      :expand-row-keys="expands"
      @selection-change="handleSelectionChange"
    >
      <!-- 这是一个具名插槽。父组件可以向这个位置插入自定义的列定义，通常用于定义“展开行”的列。这使得父组件可以自定义展开按钮的样式和行为。 -->
      <slot name="expandColumn"></slot>
      <!-- 序号列 -->
      <el-table-column
        v-if="showIndex && !showSelection"
        label="序号"
        type="index"
        :index="indexMethod"
        align="center"
        width="30"
        :fixed="fixedIndex || false"
      >
      </el-table-column>
      <!-- 多选列（批量操作时替代序号列） -->
      <el-table-column
        v-if="showSelection"
        type="selection"
        align="center"
        width="40"
        :fixed="fixedIndex || false"
      >
      </el-table-column>

      <template v-for="item in finalColumns">

        <!-- 步骤条 进度条列 -->
        <el-table-column
          v-if="item.custom && item.column.type == 'progress'"
          :key="item.prop"
          show-overflow-tooltip
          :prop="item.prop"
          :label="item.label"
          :width="item.column.width || '110'"
          sortable

        >
          <template slot="header" slot-scope="scope">
            <el-popover
              placement="bottom-start"
              trigger="manual"
              :value="filterVisible[scope.column.property]"
              append-to-body
              popper-class="column-filter-popover"
              :close-on-click-outside="true"
              @click.stop
            >
              <span
                slot="reference"
                style="display:flex;align-items:center;cursor:pointer;"
              >
                <span>{{ scope.column.label }}</span>
                <span
                  v-if="item.filterable"
                  @click.stop="
                    (item.filterType === 'date' || item.filterType === 'dateFrom')
                      ? toggleDateFilter(scope.column.property)
                      : toggleFilter(scope.column.property)
                  "
                  style="margin-left:6px; cursor:pointer; display:inline-flex; width:20px; height:25px; align-items:center; justify-content:center;"
                >
                  <svg
                    viewBox="0 0 1024 1024"
                    width="12"
                    height="12"
                    :fill="filterValues[scope.column.property] ? '#2564CF' : 'none'"
                    :stroke="filterValues[scope.column.property] ? '#2564CF' : '#909399'"
                    stroke-width="48"
                  >
                    <path d="M170.666667 128l682.666666 0 0 106.666667-256 320 0 341.333333-170.666666 0 0-341.333333-256-320 0-106.666667z" />
                  </svg>
                </span>
              </span>

              <div style="padding:6px;" v-if="!item.filterType || item.filterType === 'keyword'">
                <el-input
                  :ref="el => filterInputRefs[scope.column.property] = el"
                  v-model="filterValues[scope.column.property]"
                  size="mini"
                  :placeholder="item.filterPlaceholder || '输入关键字筛选'"
                  clearable
                  @clear="clearColumnFilter(scope.column.property)"
                  @keyup.enter.native="confirmFilter(scope.column.property)"
                  style="width:150px;"
                />
              </div>
              <div style="padding:6px;" v-if="item.filterType === 'date'">
                <el-date-picker
                  :ref="el => dateFilterRefs[scope.column.property] = el"
                  v-model="dateFilterValues[scope.column.property]"
                  type="daterange"
                  size="mini"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  style="width:240px;"
                  @change="handleDateFilterChange(scope.column.property)"
                  @clear="onDatePickerClear(scope.column.property)"
                />
              </div>
              <div style="padding:0 6px 6px;text-align:right;">
                <el-button
                  type="primary"
                  size="mini"
                  @click="confirmFilter(scope.column.property)"
                >
                  确定
                </el-button>
                <el-button
                  size="mini"
                  @click="cancelFilter(scope.column.property)"
                >
                  取消
                </el-button>
              </div>
            </el-popover>
          </template>

          <template slot-scope="scope">
            <div class="progress-cell">
              <!-- ✅ BOM进度：0-1 转百分比，物料属性为外购时不显示进度条 -->
              <template v-if="item.column.type == 'progress' && item.column.field == 'BOM进度'">
                <el-progress
                  v-if="scope.row['物料属性'] !== '外购'"
                  :percentage="dealProgress(scope.row[item.column.field]) * 100"
                  :color="customColors"
                ></el-progress>
              </template>

              <!-- ✅ 领料比：0-1 转百分比 -->
              <el-progress
                v-else-if="item.column.type == 'progress' && item.column.field == '领料/投料'"
                :percentage="Number((dealProgress(scope.row[item.column.field]) * 100).toFixed(2))"
                :color="customColors"
              ></el-progress>

              <!-- ✅ 回款比例 -->
              <el-progress
                v-else-if="item.column.type == 'progress' && item.column.field == '回款比例'"
                :percentage="dealProgress(scope.row[item.column.field]) * 100"
                :color="customColors"
              ></el-progress>

              <!-- ✅ 其他进度条（默认） -->
              <el-progress
                v-else
                :percentage="dealProgress(scope.row[item.column.field])"
                :color="customColors"
              ></el-progress>
            </div>
          </template>
        </el-table-column>


        <!-- 链接列（可点击的蓝色文本） -->
        <el-table-column
          v-if="item.custom && item.column.type == 'link'"
          :key="item.prop"
          :prop="item.prop"
          :fixed="item.fixed || false"
          :label="item.label"
          :width="item.width"   
          sortable

        >
          <template slot="header" slot-scope="scope">
            <el-popover
              placement="bottom-start"
              trigger="manual"
              :value="filterVisible[scope.column.property]"
              append-to-body
              popper-class="column-filter-popover"
              :close-on-click-outside="true"
              @click.stop
            >
              <!-- ✅ reference：只写一次 -->
              <span
                slot="reference"
                style="display:flex;align-items:center;cursor:pointer;"
              >
                <span>{{ scope.column.label }}</span>

                <!-- ✅ 漏斗（仅 filterable 为 true 时显示） -->
              <span
                v-if="item.filterable"
                @click.stop="
                  item.filterType === 'date'
                    ? toggleDateFilter(scope.column.property)
                    : toggleFilter(scope.column.property)
                "
                style="margin-left:6px; cursor:pointer; display:inline-flex; width:20px; height:25px; align-items:center; justify-content:center;"
              >
                  <svg
                    viewBox="0 0 1024 1024"
                    width="12"
                    height="12"
                    :fill="filterValues[scope.column.property] ? '#2564CF' : 'none'"
                    :stroke="filterValues[scope.column.property] ? '#2564CF' : '#909399'"
                    stroke-width="48"
                  >
                    <path d="M170.666667 128l682.666666 0 0 106.666667-256 320 0 341.333333-170.666666 0 0-341.333333-256-320 0-106.666667z" />
                  </svg>
                </span>

              </span>

      <!-- ✅ 筛选输入框（关键字） -->
      <div style="padding:6px;" v-if="!item.filterType || item.filterType === 'keyword'">
        <el-input
          :ref="el => filterInputRefs[scope.column.property] = el"
          v-model="filterValues[scope.column.property]"
          size="mini"
          :placeholder="item.filterPlaceholder || '输入关键字筛选'"
          clearable
          @clear="clearColumnFilter(scope.column.property)"
          @keyup.enter.native="confirmFilter(scope.column.property)"
          style="width:150px;"
        />
      </div>
      <!-- ✅ 时间范围筛选器 -->
      <div style="padding:6px;" v-if="item.filterType === 'date'">
        <el-date-picker
          :ref="el => dateFilterRefs[scope.column.property] = el"
          v-model="dateFilterValues[scope.column.property]"
          type="daterange"
          size="mini"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          style="width:240px;"
          @change="handleDateFilterChange(scope.column.property)"
        />
      </div>
      <!-- ✅ 下拉框筛选器 -->
      <div style="padding:6px;" v-if="item.filterType === 'select'">
        <el-select
          v-model="filterValues[scope.column.property]"
          size="mini"
          placeholder="请选择"
          clearable
          style="width:150px;"
        >
          <el-option
            v-for="opt in (item.filterOptions || [])"
            :key="opt.value"
            :value="opt.value"
            :label="opt.label"
          ></el-option>
        </el-select>
      </div>
      <!-- ✅ 快捷时间范围 + 自定义日期（dateSelect） -->
      <div style="padding:6px;" v-if="item.filterType === 'dateSelect'">
        <el-select
          v-model="dateSelectType[scope.column.property]"
          size="mini"
          placeholder="选择时间范围"
          style="width:150px;"
          @change="handleDateSelectTypeChange(scope.column.property)"
          @visible-change="handleDateSelectVisibleChange(scope.column.property, $event)"
        >
          <el-option label="所有" value="all" />
          <el-option label="本年" value="year" />
          <el-option label="本月" value="month" />
          <el-option label="本周" value="week" />
          <el-option label="自定义" value="custom" />
        </el-select>

        <el-date-picker
          v-if="dateSelectPickerVisible[scope.column.property]"
          :ref="el => setDateSelectPickerRef(scope.column.property, el)"
          v-model="dateSelectRange[scope.column.property]"
          type="daterange"
          size="mini"
          popper-class="date-range-small custom-date-popper"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="handleDateSelectRangeChange(scope.column.property)"
          @blur="dateSelectPickerVisible[scope.column.property] = false"
        />
      </div>
              <!-- ✅ 当前已生效的筛选条件（打开弹层就能看到之前设的是什么） -->
              <!-- <div
                v-if="filterSummary(scope.column.property)"
                style="padding:0 6px 4px; font-size:12px; color:#606266;"
              >
                当前：{{ filterSummary(scope.column.property) }}
              </div> -->

              <!-- ✅ 确定 / 清空 / 取消按钮 -->
              <div style="padding:0 6px 6px;text-align:right;">
                <el-button
                  type="primary"
                  size="mini"
                  @click="
                    item.filterType === 'date'
                      ? confirmDateFilter(scope.column.property)
                      : item.filterType === 'dateFrom'
                        ? confirmDateFromFilter(scope.column.property)
                        : item.filterType === 'dateEqual'
                          ? confirmDateEqualFilter(scope.column.property)
                          : item.filterType === 'dateSelect'
                            ? confirmDateSelectFilter(scope.column.property)
                            : confirmFilter(scope.column.property)
                  "
                >
                  确定
                </el-button>

                <!-- ✅ 清空：× 一下就清掉当前列的筛选条件并立即生效
                <el-button
                  v-if="hasFilterValue(scope.column.property)"
                  size="mini"
                  @click="clearCurrentFilter(scope.column.property)"
                >
                  清空
                </el-button> -->

                <!-- ✅ 新增：取消按钮 -->
                <el-button
                  size="mini"
                  @click="cancelFilter(scope.column.property)"
                >
                  取消
                </el-button>

              </div>
            </el-popover>
          </template>

          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              placement="top"
              :content="scope.row[item.prop]"
              :enterable="true"
              :hide-after="0"
              :open-delay="200"
            >      
            <!-- 可配置的链接样式
                 ✅ 行级禁用（column.disabledField / disabledValues）：命中的行不加链接样式、
                    不可点击，显示成普通文本（见 isLinkDisabled） -->
            <span
              class="custom-link"
              :class="{ 'is-disabled': isLinkDisabled(scope.row, item) }"
              :style="isLinkDisabled(scope.row, item) ? null : getLinkStyle(item.column)"
              @click="handleLinkClick(scope.row, item)"
              style="display: inline-block; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
            >
              {{ getLinkText(scope.row, item) }}
            </span>

            </el-tooltip> 
          </template>
        </el-table-column>





        <!-- 评审进度链接列（仅暂存可点击，气泡显示参与人） -->
        <el-table-column
          v-if="item.custom && item.column.type == 'reviewLink'"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.minWidth || 60"
          :align="item.align || 'left'"
          sortable
        >
          <template slot="header" slot-scope="scope">
            <el-popover
              placement="bottom-start"
              trigger="manual"
              :value="filterVisible[scope.column.property]"
              append-to-body
              popper-class="column-filter-popover"
              :close-on-click-outside="true"
              @click.stop
            >
              <span
                slot="reference"
                style="display:flex;align-items:center;cursor:pointer;"
              >
                <span>{{ scope.column.label }}</span>
                <span
                  v-if="item.filterable"
                  @click.stop="toggleFilter(scope.column.property)"
                  style="margin-left:6px; cursor:pointer; display:inline-flex; width:20px; height:25px; align-items:center; justify-content:center;"
                >
                  <svg
                    viewBox="0 0 1024 1024"
                    width="12"
                    height="12"
                    :fill="filterValues[scope.column.property] ? '#2564CF' : 'none'"
                    :stroke="filterValues[scope.column.property] ? '#2564CF' : '#909399'"
                    stroke-width="48"
                  >
                    <path d="M170.666667 128l682.666666 0 0 106.666667-256 320 0 341.333333-170.666666 0 0-341.333333-256-320 0-106.666667z" />
                  </svg>
                </span>
              </span>
              <!-- ✅ 下拉框筛选（filterType:'select'）：选项由列配置 filterOptions 提供
                   例：评审进度只允许「暂存」「已审核」，避免手输任意关键词 -->
              <div v-if="item.filterType === 'select'" style="padding:6px;">
                <el-select
                  v-model="filterValues[scope.column.property]"
                  size="mini"
                  clearable
                  :placeholder="item.filterPlaceholder || '请选择'"
                  style="width:150px;"
                  @clear="clearCurrentFilter(scope.column.property)"
                >
                  <el-option
                    v-for="opt in (item.filterOptions || [])"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  />
                </el-select>
              </div>
              <div v-else style="padding:6px;">
                <el-input
                  :ref="el => filterInputRefs[scope.column.property] = el"
                  v-model="filterValues[scope.column.property]"
                  size="mini"
                  :placeholder="item.filterPlaceholder || '输入关键字筛选'"
                  clearable
                  @clear="clearColumnFilter(scope.column.property)"
                  @keyup.enter.native="confirmFilter(scope.column.property)"
                  style="width:150px;"
                />
              </div>
              <div style="padding:0 6px 6px;text-align:right;">
                <el-button
                  type="primary"
                  size="mini"
                  @click="confirmFilter(scope.column.property)"
                >
                  确定
                </el-button>
                <el-button
                  size="mini"
                  @click="cancelFilter(scope.column.property)"
                >
                  取消
                </el-button>
              </div>
            </el-popover>
          </template>

          <template slot-scope="scope">
            <template v-if="scope.row[item.column.field] === '暂存'">
              <el-popover
                placement="top"
                trigger="click"
                append-to-body
                popper-class="review-participants-popover"
                @show="handleReviewLinkClick(scope.row, item)"
              >
                <div v-if="scope.row._reviewParticipants" style="max-width:400px; word-break:break-all; padding:4px 8px; font-size:13px; line-height:1.6;">
                  {{ scope.row._reviewParticipants }}
                </div>
                <div v-else style="max-width:400px; padding:8px 12px; font-size:13px; color:#909399;">
                  加载中...
                </div>
                <span
                  slot="reference"
                  class="custom-link review-link"
                  style="display:inline-block; max-width:100%; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;"
                >
                  {{ scope.row[item.column.field] }}
                </span>
              </el-popover>
            </template>
            <template v-else>
              <span style="color:#606266;">
                {{ scope.row[item.column.field] }}
              </span>
            </template>
          </template>
        </el-table-column>


        <!-- 图标列 -->
        <el-table-column
          v-if="item.custom && item.column.type == 'icon'"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :fixed="item.fixed || false"
          :align="item.align || 'left'"
          :width="item.width"
          :min-width="item.minWidth || 50"
          sortable
        >
          <template slot="header" slot-scope="scope">
            <el-popover
              placement="bottom-start"
              trigger="manual"
              :value="filterVisible[scope.column.property]"
              append-to-body
              popper-class="column-filter-popover"
              :close-on-click-outside="true"
              @click.stop
            >
              <span
                slot="reference"
                style="display:flex;align-items:center;cursor:pointer;"
              >
                <span>{{ scope.column.label }}</span>
                <span
                  v-if="item.filterable"
                  @click.stop="toggleFilter(scope.column.property)"
                  style="margin-left:6px; cursor:pointer; display:inline-flex; width:20px; height:25px; align-items:center; justify-content:center;"
                >
                  <svg
                    viewBox="0 0 1024 1024"
                    width="12"
                    height="12"
                    :fill="filterValues[scope.column.property] ? '#2564CF' : 'none'"
                    :stroke="filterValues[scope.column.property] ? '#2564CF' : '#909399'"
                    stroke-width="48"
                  >
                    <path d="M170.666667 128l682.666666 0 0 106.666667-256 320 0 341.333333-170.666666 0 0-341.333333-256-320 0-106.666667z" />
                  </svg>
                </span>
              </span>
              <!-- select 下拉筛选 -->
              <template v-if="item.filterType === 'select' && item.filterOptions">
                <div style="padding:6px;">
                  <el-select
                    :ref="el => filterInputRefs[scope.column.property] = el"
                    v-model="filterValues[scope.column.property]"
                    size="mini"
                    placeholder="请选择"
                    clearable
                    @clear="clearColumnFilter(scope.column.property)"
                    style="width:150px;"
                  >
                    <el-option
                      v-for="opt in item.filterOptions"
                      :key="opt.value"
                      :label="opt.label"
                      :value="opt.value"
                    />
                  </el-select>
                </div>
                <div style="padding:0 6px 6px;text-align:right;">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="confirmFilter(scope.column.property)"
                  >
                    确定
                  </el-button>
                  <el-button
                    size="mini"
                    @click="cancelFilter(scope.column.property)"
                  >
                    取消
                  </el-button>
                </div>
              </template>
              <!-- text 关键字筛选 -->
              <template v-if="!item.filterType || item.filterType === 'text'">
                <div style="padding:6px;">
                  <el-input
                    :ref="el => filterInputRefs[scope.column.property] = el"
                    v-model="filterValues[scope.column.property]"
                    size="mini"
                    :placeholder="item.filterPlaceholder || '输入关键字筛选'"
                    clearable
                    @clear="clearColumnFilter(scope.column.property)"
                    @keyup.enter.native="confirmFilter(scope.column.property)"
                    style="width:150px;"
                  />
                </div>
                <div style="padding:0 6px 6px;text-align:right;">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="confirmFilter(scope.column.property)"
                  >
                    确定
                  </el-button>
                  <el-button
                    size="mini"
                    @click="cancelFilter(scope.column.property)"
                  >
                    取消
                  </el-button>
                </div>
              </template>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <!-- 使用 el-tooltip 实现悬停提示 -->
            <el-tooltip
              :content="getIconTooltip(scope.row, item.column.tooltipField)"
              placement="top"
            >
              <!-- 关键：使用一个div来绘制实心圆，其颜色由 getStatusCircleClass 方法决定 -->
              <div
                :class="getStatusCircleClass(scope.row[item.prop])"
                class="status-circle-base"
                @click="handleIconClick(scope.row, item)"
              >
                <!-- 移除了 <i> 标签，因为实心圆用CSS绘制 -->
              </div>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- 标签列 -->
        <el-table-column
          v-if="item.custom && item.column.type == 'tag'"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :min-width="item.minWidth || 50"
          :align="item.align || 'left'"
          sortable
        >
          <template slot="header" slot-scope="scope">
            <el-popover
              placement="bottom-start"
              trigger="manual"
              :value="filterVisible[scope.column.property]"
              append-to-body
              popper-class="column-filter-popover"
              :close-on-click-outside="true"
              @click.stop
            >
              <span
                slot="reference"
                style="display:flex;align-items:center;cursor:pointer;"
              >
                <span>{{ scope.column.label }}</span>
                <span
                  v-if="item.filterable"
                  @click.stop="toggleFilter(scope.column.property)"
                  style="margin-left:6px; cursor:pointer; display:inline-flex; width:20px; height:25px; align-items:center; justify-content:center;"
                >
                  <svg
                    viewBox="0 0 1024 1024"
                    width="12"
                    height="12"
                    :fill="filterValues[scope.column.property] ? '#2564CF' : 'none'"
                    :stroke="filterValues[scope.column.property] ? '#2564CF' : '#909399'"
                    stroke-width="48"
                  >
                    <path d="M170.666667 128l682.666666 0 0 106.666667-256 320 0 341.333333-170.666666 0 0-341.333333-256-320 0-106.666667z" />
                  </svg>
                </span>
              </span>
              <!-- keyword 关键字筛选 -->
              <template v-if="!item.filterType || item.filterType === 'text'">
                <div style="padding:6px;">
                  <el-input
                    :ref="el => filterInputRefs[scope.column.property] = el"
                    v-model="filterValues[scope.column.property]"
                    size="mini"
                    :placeholder="item.filterPlaceholder || '输入关键字筛选'"
                    clearable
                    @clear="clearColumnFilter(scope.column.property)"
                    @keyup.enter.native="confirmFilter(scope.column.property)"
                    style="width:150px;"
                  />
                </div>
                <div style="padding:0 6px 6px;text-align:right;">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="confirmFilter(scope.column.property)"
                  >
                    确定
                  </el-button>
                  <el-button
                    size="mini"
                    @click="cancelFilter(scope.column.property)"
                  >
                    取消
                  </el-button>
                </div>
              </template>
              <!-- select 下拉筛选 -->
              <template v-if="item.filterType === 'select' && item.filterOptions">
                <div style="padding:6px;">
                  <el-select
                    :ref="el => filterInputRefs[scope.column.property] = el"
                    v-model="filterValues[scope.column.property]"
                    size="mini"
                    placeholder="请选择"
                    clearable
                    @clear="clearColumnFilter(scope.column.property)"
                    style="width:150px;"
                  >
                    <el-option
                      v-for="opt in item.filterOptions"
                      :key="opt.value"
                      :label="opt.label"
                      :value="opt.value"
                    />
                  </el-select>
                </div>
                <div style="padding:0 6px 6px;text-align:right;">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="confirmFilter(scope.column.property)"
                  >
                    确定
                  </el-button>
                  <el-button
                    size="mini"
                    @click="cancelFilter(scope.column.property)"
                  >
                    取消
                  </el-button>
                </div>
              </template>
              <!-- date 日期范围筛选 -->
              <template v-if="item.filterType === 'date'">
                <div style="padding:6px;">
                  <el-date-picker
                    :ref="el => filterInputRefs[scope.column.property] = el"
                    v-model="filterValues[scope.column.property]"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    size="mini"
                    style="width:220px;"
                  />
                </div>
                <div style="padding:0 6px 6px;text-align:right;">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="confirmDateFromFilter(scope.column.property)"
                  >
                    确定
                  </el-button>
                  <el-button
                    size="mini"
                    @click="cancelFilter(scope.column.property)"
                  >
                    取消
                  </el-button>
                </div>
              </template>
              <!-- dateEqual 单日期筛选 -->
              <template v-if="item.filterType === 'dateEqual'">
                <div style="padding:6px;">
                  <el-date-picker
                    :ref="el => filterInputRefs[scope.column.property] = el"
                    v-model="filterValues[scope.column.property]"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    size="mini"
                    style="width:160px;"
                  />
                </div>
                <div style="padding:0 6px 6px;text-align:right;">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="confirmDateEqualFilter(scope.column.property)"
                  >
                    确定
                  </el-button>
                  <el-button
                    size="mini"
                    @click="cancelFilter(scope.column.property)"
                  >
                    取消
                  </el-button>
                </div>
              </template>
              <!-- dateSelect 日期下拉筛选 -->
              <template v-if="item.filterType === 'dateSelect'">
                <div style="padding:6px;">
                  <el-select
                    :ref="el => filterInputRefs[scope.column.property] = el"
                    v-model="filterValues[scope.column.property]"
                    size="mini"
                    placeholder="选择时间范围"
                    clearable
                    @clear="clearColumnFilter(scope.column.property)"
                    style="width:150px;"
                  >
                    <el-option label="近一周" value="7" />
                    <el-option label="近一月" value="30" />
                    <el-option label="近三月" value="90" />
                  </el-select>
                </div>
                <div style="padding:0 6px 6px;text-align:right;">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="confirmDateSelectFilter(scope.column.property)"
                  >
                    确定
                  </el-button>
                  <el-button
                    size="mini"
                    @click="cancelFilter(scope.column.property)"
                  >
                    取消
                  </el-button>
                </div>
              </template>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <el-tag
              :type="getTagType(scope.row[item.prop], item.column.tag)"
              size="small"
              :class="{ 'tag-clickable': item.column.clickable }"
              @click="item.column.clickable && handleTagClick(scope.row, item)"
            >
              {{ getTagText(scope.row[item.prop], item.column.tag) }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 开关列 -->
        <el-table-column
          v-if="item.custom && item.column.type == 'switch'"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          align="left"
          :class-name="item.className || ''"
          width="80"
        >
          <template slot-scope="scope">
            <!--
              active-color: 打开时的颜色
              inactive-color: 关闭时的颜色
              :value: 双向绑定，根据 scope.row[item.prop] 的值确定开关状态
              @change: 开关状态变化时触发的事件
            -->
            <el-switch
              v-model="scope.row[item.column.field]"
              :active-value="1"
              :inactive-value="0"
              active-color="#2564CFCC"
              inactive-color=""
              @change="handleSwitchChange(scope.row, item, scope.$index)"
            >
            </el-switch>
          </template>
        </el-table-column>

        <!-- 日期编辑列 -->
        <el-table-column
          v-if="item.custom && item.column.type == 'dateEdit'"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :align="item.align || 'left'"
          :width="item.column.width "
          sortable
        >
          <template slot-scope="scope">
            <el-popover
              placement="bottom-start"
              trigger="manual"
              :value="dateEditVisible[scope.$index]"
              append-to-body
              popper-class="column-filter-popover"
              @click.stop
            >
              <!-- ✅ reference：只包文字 + 铅笔 -->
              <span slot="reference" class="edit-container">
                <el-tooltip
                  effect="dark"
                  placement="top"
                  :content="formatDateDisplay(scope.row[item.column.field], item.column.dateFormat)"
                  :disabled="dateEditVisible[scope.$index]"
                >
                  <span class="date-display">
                    {{ formatDateDisplay(scope.row[item.column.field], item.column.dateFormat) }}
                  </span>
                </el-tooltip>

                <el-button
                  type="text"
                  icon="el-icon-edit"
                  size="mini"
                  class="edit-btn"
                  @click.stop="handleDateEditClick(scope.row, item, scope.$index)"
                ></el-button>
              </span>

              <!-- ✅ 日期选择框 -->
              <div style="padding:6px;">
                <el-date-picker
                  :ref="el => setDateEditRef(scope.$index, el)"
                  v-model="dateEditValues[scope.$index]"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  size="mini"
                  style="width:180px;"
                />
              </div>

              <!-- ✅ 保存 / 取消 -->
              <div style="padding:0 6px 6px;text-align:right;">
                <el-button
                  type="primary"
                  size="mini"
                  @click="saveDateEdit(scope.row, item, scope.$index)"
                >
                  保存
                </el-button>
                <el-button
                  size="mini"
                  @click="cancelDateEdit(scope.$index)"
                >
                  取消
                </el-button>
              </div>
            </el-popover>
          </template>
        </el-table-column>

        <!-- 文本编辑列 -->
        <el-table-column
          v-if="item.custom && item.column.type == 'textEdit'"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :align="item.align || 'left'"
          :width="item.column.width "
          sortable
        >
          <!-- 表头：筛选漏斗（仅关键字筛选，不提供时间筛选） -->
          <template slot="header" slot-scope="scope">
            <el-popover
              placement="bottom-start"
              trigger="manual"
              :value="filterVisible[scope.column.property]"
              append-to-body
              popper-class="column-filter-popover"
              :close-on-click-outside="true"
              @click.stop
            >
              <span slot="reference" style="display:flex;align-items:center;cursor:pointer;">
                <span>{{ scope.column.label }}</span>
                <span
                  v-if="item.filterable"
                  @click.stop="toggleFilter(scope.column.property)"
                  style="margin-left:6px; cursor:pointer; display:inline-flex; width:20px; height:25px; align-items:center; justify-content:center;"
                >
                  <svg
                    viewBox="0 0 1024 1024"
                    width="12"
                    height="12"
                    :fill="filterValues[scope.column.property] ? '#2564CF' : 'none'"
                    :stroke="filterValues[scope.column.property] ? '#2564CF' : '#909399'"
                    stroke-width="48"
                  >
                    <path d="M170.666667 128l682.666666 0 0 106.666667-256 320 0 341.333333-170.666666 0 0-341.333333-256-320 0-106.666667z" />
                  </svg>
                </span>
              </span>
              <!-- 关键字筛选输入框 -->
              <!-- ✅ 下拉框筛选（filterType:'select'）：选项由列配置 filterOptions 提供
                   例：评审进度只允许「暂存」「已审核」，避免手输任意关键词 -->
              <div v-if="item.filterType === 'select'" style="padding:6px;">
                <el-select
                  v-model="filterValues[scope.column.property]"
                  size="mini"
                  clearable
                  :placeholder="item.filterPlaceholder || '请选择'"
                  style="width:150px;"
                  @clear="clearCurrentFilter(scope.column.property)"
                >
                  <el-option
                    v-for="opt in (item.filterOptions || [])"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  />
                </el-select>
              </div>
              <div v-else style="padding:6px;">
                <el-input
                  :ref="el => filterInputRefs[scope.column.property] = el"
                  v-model="filterValues[scope.column.property]"
                  size="mini"
                  :placeholder="item.filterPlaceholder || '输入关键字筛选'"
                  clearable
                  @clear="clearColumnFilter(scope.column.property)"
                  @keyup.enter.native="confirmFilter(scope.column.property)"
                  style="width:150px;"
                />
              </div>

              <!-- ✅ 当前已生效的筛选条件 -->
              <div
                v-if="filterSummary(scope.column.property)"
                style="padding:0 6px 4px; font-size:12px; color:#606266;"
              >
                当前：{{ filterSummary(scope.column.property) }}
              </div>

              <div style="padding:0 6px 6px;text-align:right;">
                <el-button
                  type="primary"
                  size="mini"
                  @click="confirmFilter(scope.column.property)"
                >
                  确定
                </el-button>
                <!-- ✅ × 清空：直接生效 -->
                <el-button
                  v-if="hasFilterValue(scope.column.property)"
                  size="mini"
                  @click="clearCurrentFilter(scope.column.property)"
                >
                  × 清空
                </el-button>
                <el-button
                  size="mini"
                  @click="cancelFilter(scope.column.property)"
                >
                  取消
                </el-button>
              </div>
            </el-popover>
          </template>

          <template slot-scope="scope">
            <el-popover
              placement="bottom-start"
              trigger="manual"
              :value="textEditVisible[scope.$index]"
              append-to-body
              popper-class="column-filter-popover"
              @click.stop
            >
              <!-- ✅ reference：只包文字 + 铅笔 -->
              <span slot="reference" class="edit-container">
                <el-tooltip
                  effect="dark"
                  placement="top"
                  :content="scope.row[item.column.field]"
                  :disabled="textEditVisible[scope.$index]"
                >
                  <span class="text-display">
                    {{ formatTextDisplay(scope.row[item.column.field], item.column.maxDisplayLength) }}
                  </span>
                </el-tooltip>

                <!-- 无编辑权限时（column.editable === false）只显示文本，不出现铅笔 -->
                <el-button
                  v-if="isTextEditEditable(item)"
                  type="text"
                  icon="el-icon-edit"
                  size="mini"
                  class="edit-btn"
                  @click.stop="handleTextEditClick(scope.row, item, scope.$index)"
                ></el-button>
              </span>

              <!-- ✅ 编辑输入框 -->
              <div style="padding:6px;">
                <el-input
                  :ref="el => setTextEditRef(scope.$index, el)"
                  v-model="textEditValues[scope.$index]"
                  type="textarea"
                  :rows="3"
                  size="mini"
                  placeholder="请输入编辑内容"
                  maxlength="500"
                  show-word-limit
                  style="width:220px;"
                />
              </div>

              <!-- ✅ 保存 / 取消 -->
              <div style="padding:0 6px 6px;text-align:right;">
                <el-button
                  type="primary"
                  size="mini"
                  @click="saveTextEdit(scope.row, item, scope.$index)"
                >
                  保存
                </el-button>
                <el-button
                  size="mini"
                  @click="cancelTextEdit(scope.$index)"
                >
                  取消
                </el-button>
              </div>
            </el-popover>
          </template>
        </el-table-column>

        <!-- 重置密码列 -->
        <el-table-column
          v-if="item.custom && item.column.type == 'resetPassword'"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          align="center"
          :width="item.column.width || '100'"
        >
          <template slot-scope="scope">
            <!-- 重置密码按钮 -->
            <el-button
              type="text"
              size="mini"
              class="reset-password-btn"
              @click.stop="handleResetPasswordClick(scope.row, item, scope.$index)"
            >
              重置
            </el-button>
          </template>
        </el-table-column>        

        <!-- 普通文本 -->
        <el-table-column
          v-if="!item.actions && !item.custom"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :min-width="item.minWidth || 60"
          :align="item.align || 'left'"
          :fixed="item.fixed || false"
          sortable
        >
          <template slot="header" slot-scope="scope">
            <el-popover
              placement="bottom-start"
              trigger="manual"
              :value="(item.filterType === 'date' || item.filterType === 'dateFrom' || item.filterType === 'dateEqual')
                ? dateFilterVisible[scope.column.property] 
                : filterVisible[scope.column.property]"
              append-to-body
              popper-class="column-filter-popover"
              :close-on-click-outside="true"
              @click.stop
            >
              <!-- ✅ reference：只写一次 -->
              <span
                slot="reference"
                style="display:flex;align-items:center;cursor:pointer;"
              >
                <span>{{ scope.column.label }}</span>

                <!-- ✅ 漏斗（仅 filterable 为 true 时显示）
                     ⚠️ 把 filterType 一并传进去：打开弹层时要按类型把「已生效的筛选值」
                        回填到编辑器里，让用户看到当前设的是什么（见 syncFilterValueToEditor） -->
                <span
                  v-if="item.filterable"
                  @click.stop="
                    (item.filterType === 'date' || item.filterType === 'dateFrom' || item.filterType === 'dateEqual')
                      ? toggleDateFilter(scope.column.property, item.filterType)
                      : toggleFilter(scope.column.property, item.filterType)
                  "
                  style="margin-left:6px; cursor:pointer; display:inline-flex; width:20px; height:25px; align-items:center; justify-content:center;"
                >
                  <svg
                    viewBox="0 0 1024 1024"
                    width="12"
                    height="12"
                    :fill="hasFilterValue(scope.column.property) ? '#2564CF' : 'none'"
                    :stroke="hasFilterValue(scope.column.property) ? '#2564CF' : '#909399'"
                    stroke-width="48"
                  >
                    <path d="M170.666667 128l682.666666 0 0 106.666667-256 320 0 341.333333-170.666666 0 0-341.333333-256-320 0-106.666667z" />
                  </svg>
                </span>

              </span>

              <!-- ✅ 筛选输入框（关键字） -->
              <div style="padding:6px;" v-if="!item.filterType || item.filterType === 'keyword'">
                <el-input
                  :ref="el => filterInputRefs[scope.column.property] = el"
                  v-model="filterValues[scope.column.property]"
                  size="mini"
                  :placeholder="item.filterPlaceholder || '输入关键字筛选'"
                  clearable
                  @clear="clearColumnFilter(scope.column.property)"
                  @keyup.enter.native="confirmFilter(scope.column.property)"
                  style="width:150px;"
                />
              </div>

              <!-- ✅ 关键字「不包含」筛选（列配置 notFilterable: true 时显示，值存 filterValues[prop + '__not']） -->
              <div style="padding:0 6px 6px;" v-if="item.notFilterable">
                <el-input
                  :ref="el => filterNotInputRefs[scope.column.property] = el"
                  :value="filterValues[scope.column.property + '__not'] || ''"
                  size="mini"
                  :placeholder="item.notFilterPlaceholder || '输入不包含的关键字'"
                  clearable
                  @input="onNotFilterInput(scope.column.property, $event)"
                  @clear="onNotFilterClear(scope.column.property)"
                  @keyup.enter.native="confirmFilter(scope.column.property)"
                  style="width:150px;"
                />
              </div>

              <!-- ✅ 时间范围筛选器 -->
              <div style="padding:6px;" v-if="item.filterType === 'date'">
                <el-date-picker
                  :ref="el => dateFilterRefs[scope.column.property] = el"
                  v-model="dateFilterValues[scope.column.property]"
                  type="daterange"
                  size="mini"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  style="width:240px;"
                  @change="handleDateFilterChange(scope.column.property)"
                  @clear="onDatePickerClear(scope.column.property)"
                />
              </div>

              <!-- ✅ 单日期筛选（不早于） -->
              <div style="padding:6px;" v-if="item.filterType === 'dateFrom'">
                <el-date-picker
                  v-model="dateFromFilterValues[scope.column.property]"
                  type="date"
                  size="mini"
                  placeholder="不早于填入日期"
                  value-format="yyyy-MM-dd"
                  style="width:180px;"
                  @change="handleDateFromFilterChange(scope.column.property)"
                  @clear="onDatePickerClear(scope.column.property)"
                />
              </div>

              <!-- ✅ 单日期筛选（筛选所选日期当天） -->
              <div style="padding:6px;" v-if="item.filterType === 'dateEqual'">
                <el-date-picker
                  v-model="dateEqualFilterValues[scope.column.property]"
                  type="date"
                  size="mini"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  style="width:180px;"
                  @change="handleDateEqualFilterChange(scope.column.property)"
                  @clear="onDatePickerClear(scope.column.property)"
                />
              </div>

              <!-- ✅ 下拉框筛选器 -->
              <div style="padding:6px;" v-if="item.filterType === 'select'">
                <el-select
                  v-model="filterValues[scope.column.property]"
                  size="mini"
                  placeholder="请选择"
                  clearable
                  style="width:150px;"
                >
                  <el-option
                    v-for="opt in (item.filterOptions || [])"
                    :key="opt.value"
                    :value="opt.value"
                    :label="opt.label"
                  ></el-option>
                </el-select>
              </div>

              <!-- ✅ 快捷时间范围 + 自定义日期（dateSelect） -->
              <div style="padding:6px;" v-if="item.filterType === 'dateSelect'">
                <el-select
                  v-model="dateSelectType[scope.column.property]"
                  size="mini"
                  placeholder="选择时间范围"
                  style="width:150px;"
                  @change="handleDateSelectTypeChange(scope.column.property)"
                  @visible-change="handleDateSelectVisibleChange(scope.column.property, $event)"
                >
                  <el-option label="所有" value="all" />
                  <el-option label="本年" value="year" />
                  <el-option label="本月" value="month" />
                  <el-option label="本周" value="week" />
                  <el-option label="自定义" value="custom" />
                </el-select>

                <!-- 自定义日期选择器（脱离 select） -->
                <el-date-picker
                  v-if="dateSelectPickerVisible[scope.column.property]"
                  :ref="el => setDateSelectPickerRef(scope.column.property, el)"
                  v-model="dateSelectRange[scope.column.property]"
                  type="daterange"
                  size="mini"
                  popper-class="date-range-small custom-date-popper"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="handleDateSelectRangeChange(scope.column.property)"
                  @clear="onDatePickerClear(scope.column.property)"
                  @blur="dateSelectPickerVisible[scope.column.property] = false"
                />
              </div>

              <!-- ✅ 当前已生效的筛选条件（打开弹层就能看到之前设的是什么） -->
              <!-- <div
                v-if="filterSummary(scope.column.property)"
                style="padding:0 6px 4px; font-size:12px; color:#606266;"
              >
                当前：{{ filterSummary(scope.column.property) }}
              </div> -->

              <!-- ✅ 确定 / 清空 / 取消按钮 -->
              <div style="padding:0 6px 6px;text-align:right;">
                <el-button
                  type="primary"
                  size="mini"
                  @click="
                    item.filterType === 'date'
                      ? confirmDateFilter(scope.column.property)
                      : item.filterType === 'dateFrom'
                        ? confirmDateFromFilter(scope.column.property)
                        : item.filterType === 'dateEqual'
                          ? confirmDateEqualFilter(scope.column.property)
                          : item.filterType === 'dateSelect'
                            ? confirmDateSelectFilter(scope.column.property)
                            : confirmFilter(scope.column.property)
                  "
                >
                  确定
                </el-button>



                <!-- ✅ 新增：取消按钮 -->
                <el-button
                  size="mini"
                  @click="cancelFilter(scope.column.property)"
                >
                  取消
                </el-button>

              </div>
            </el-popover>
          </template>

          <template slot-scope="scope">
        <el-tooltip
          effect="dark"
          placement="top"
          :content="scope.row[item.prop]"
          :hide-after="100"
          :open-delay="200"
          :enterable="true"
          :popper-class="'copy-tooltip-long ' + (tooltipPopperClass || '')"
        >
          <span class="copy-cell copy-cell-fix">
            {{ scope.row[item.prop] }}
          </span>
        </el-tooltip>
          </template>
        </el-table-column>

        <!-- 操作栏 -->
        <el-table-column
          v-if="item.actions"
          :key="item.prop"
          label="操作"
          :width="item.width"
          :fixed="item.fixed || false"
          :align="item.align || 'left'"
        >
          <template slot-scope="scope">
            <!-- ✅ 条件未满足（如售后次数为 0）：不渲染按钮，显示成灰色文本，不可点击
                 灰色 = 不可用态，和可点的蓝色链接明显区分 -->
            <span
              v-if="!isActionEnabled(scope.row, item)"
              style="color:#909399; cursor:default;"
            >
              {{ (item.actions || []).map(a => a.label).join(' ') }}
            </span>
            <template v-else>
              <template v-for="(fn, index) in item.actions">
                <!-- ✅ 配了启用条件的列（如合同主页「售后」）：用评审进度列同款蓝色链接样式
                     ⚠️ Vue 2 不允许 <template> 带 key，key 必须放在真实元素上（v-if/v-else
                        两个分支用不同前缀，避免复用时串位） -->
                <span
                  v-if="item.actionEnabledField"
                  :key="'act-link-' + index"
                  class="custom-link review-link"
                  style="display:inline-block; margin-right:8px;"
                  @click="handleClick(scope.row, fn.fnName)"
                >
                  {{ fn.label }}
                </span>
                <!-- 其它页面操作列保持原样，不受影响 -->
                <el-button
                  v-else
                  :key="'act-btn-' + index"
                  type="text"
                  size="mini"
                  @click="handleClick(scope.row, fn.fnName)"
                >
                  {{ fn.label }}
                </el-button>
              </template>
            </template>
          </template>
        </el-table-column>



      </template>
    </el-table>


    <paging
      @sizeChange="handleSizeChanges"
      :showPaging="showPaging"
      :responsive="pagingResponsive"
      @currentChange="handleCurrentChanges"
      :current="currentPage"
      :total="total"
      :pageSizes="pageSizes"
      :size="size"
    ></paging>


  </div>
</template>

<script>
import Sortable from 'sortablejs';
// import { number } from 'echarts';
export default {
  name: 'card-table',
  // props(组件属性):定义了父组件可以传入的所有参数，是组件可配置性的核心。例如 tableData（表格数据）、tableColumn（列配置，必需）、total（数据总数）、loading（加载状态）、pageSizes（分页大小选项）、height（表格高度）等。
  props: {
    showIndex: { // 【新增】: 控制是否显示序号列
      type: Boolean,
      default: true // 默认显示序号列
    },
    showSelection: { // 【新增】: 批量操作时用多选列替代序号列
      type: Boolean,
      default: false
    },
    fixedIndex: { // 序号列固定位置，可选 'left' / 'right'，不传则不固定
      type: String,
      default: ''
    },
    action: {
      type: Boolean,
      default: true
    },

    /* 单元格悬浮 tooltip 的自定义 popper 类名。
       ⚠️ 这个 popper 是 appendToBody 挂到 body 上的，父组件的 scoped / ::v-deep 都够不着，
          所以要单独开一个 prop 让调用页能给它加类名，再在调用页写「不带 scoped」的样式。 */
    tooltipPopperClass: {
      type: String,
      default: ''
    },

    /* ✅ 行唯一标识字段名（可选）：传了它，展开行才走「受控展开」
       （Element 的 expand-row-keys 要求同时给 row-key，否则会报 prop row-key is required）。
       不传 = 维持原行为（用 row.id），其它页面完全不受影响。 */
    rowKey: {
      type: String,
      default: ''
    },

    /* ✅ 内部分页组件是否响应式（默认 true = 维持原行为）。
       传 false：手机端也用 PC 版分页，配合 mobileColumns 可做到「手机 / 电脑显示完全一致」。 */
    pagingResponsive: {
      type: Boolean,
      default: true
    },

    /* ✅ 允许多行同时展开（默认 false = 维持原来「一次只能展开一行」的行为）。
       需要 rowKey（或行上自带 id）才能正确对应到展开行。 */
    expandMultiple: {
      type: Boolean,
      default: false
    },

    showPaging: {
      type: Boolean,
      default: true
    },
    tableData: {
      type: Array,
      required: false,
      default: () => []
    },
    tableColumn: {
      type: Array,
      required: true,
      default: () => []
    },

    mobileColumns: {
      type: Array,
      default: () => []
    },  

    total: {
      type: Number,
      required: false,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    pageSizes: {
      type: Array,
      default: ()=>[50, 100, 200, 300, 400, 500]
    },
    tableID: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 50
    },
    currentPage: {
      type: Number,
      default: 1
    },
    // ✅ 新增（关键）
    rowClassName: {
      type: Function,
      default: () => ''
    },
    // ✅ 是否启用列头拖拽排序
    columnDraggable: {
      type: Boolean,
      default: false
    },
    // ✅ 是否允许拖拽调整列宽
    columnResizable: {
      type: Boolean,
      default: true
    },
    // ✅ 从父组件接收列筛选值，用于恢复漏斗图标实心状态
    columnFilterValues: {
      type: Object,
      default: () => ({})
    }
  },
  // 输一个字就筛一次
  // watch: {
  //   filterValues: {
  //     deep: true,
  //     handler(val) {
  //       this.$emit('column-filter-change', val);
  //     }
  //   }
  // },
  // data()(组件内部数据):
  // 定义了组件内部的状态，如 expands（当前展开行的ID数组）、cardTable（样式类名）、customColors（进度条颜色梯度规则）。
  data() {
    return {
      expands: [],
      cardTable: 'card-table',
      customColors: [
        { color: '#f56c6c', percentage: 30 },
        { color: '#e6a23c', percentage: 70 },
        { color: '#67c23a', percentage: 100 }
      ],

    // ✅ 当前正在打开筛选的字段
    currentFilterProp: '',
    filterValues: {},
    filterVisible: {},
    filterInputRefs: {},
    filterNotInputRefs: {}, // ✅ 关键字「不包含」筛选输入框 ref
    // ✅ 新增：时间筛选
    dateFilterValues: {},   // { 列prop: [start, end] }
    dateFromFilterValues: {}, // { 列prop: 'yyyy-MM-dd' }  单日期筛选（不早于）
    dateEqualFilterValues: {}, // { 列prop: 'yyyy-MM-dd' }  单日期筛选（当天）
    dateFilterVisible: {},  // { 列prop: true/false }

    // ✅ 新增：dateSelect 快捷时间范围 + 自定义日期
    dateSelectType: {},            // { 列prop: 'all'|'year'|'month'|'week'|'custom' }
    dateSelectPickerVisible: {},   // { 列prop: true/false }
    dateSelectRange: {},           // { 列prop: [start, end] }
    dateSelectPickerRefs: {},      // { 列prop: el }

    textEditVisible: {},
    textEditValues: {},
    textEditRefs: {},
    
    // ✅ 新增日期编辑相关状态
    dateEditVisible: {},
    dateEditValues: {},
    dateEditRefs: {},

    // ✅ 列拖拽排序
    sortableInstance: null,
    internalColumns: [],
    tableRenderKey: 0,
    columnUserReordered: false,

    // ✅ 列宽拖拽调整
    columnResizeData: null,  // { startX, startWidth, colIndex, th, offset, colgroup }
    resizeBound: false
    };
  },
computed: {
  computedHeight() {
    if (this.height) {
      return this.height;
    }
    return this.showPaging
      ? 'calc(100% - 27px)'
      : 'calc(100% - 5px)';
  },

  finalColumns() {
    const isMobile = window.innerWidth <= 768;

    // PC：全部显示
    if (!isMobile) return this.internalColumns;

    // 手机：优先使用父组件声明的 mobileColumns
    if (this.mobileColumns.length) {
      return this.internalColumns.filter(col =>
        this.mobileColumns.includes(col.prop)
      );
    }

    // 兜底：使用列自身声明 showOnMobile
    return this.internalColumns.filter(col => col.showOnMobile === true);
  }
},

watch: {
  // ✅ 列拖拽：首次将 tableColumn 同步到 internalColumns
  tableColumn: {
    immediate: true,
    handler(val) {
      if (!this.columnUserReordered) {
        const next = val ? [...val] : [];
        const prev = this.internalColumns || [];
        // 判断列配置（数量/顺序）是否实际发生变化
        const changed =
          next.length !== prev.length ||
          next.some((col, i) => (prev[i] ? col.prop !== prev[i].prop : true)) ||
          prev.some((col, i) => (next[i] ? col.prop !== next[i].prop : true));
        this.internalColumns = next;
        // Element UI 的 el-table 在动态增删/调整 el-table-column 后不会自动刷新列布局，
        // 必须通过 tableRenderKey++ 强制完全重渲染（与下方拖拽排序、列宽调整的处理方式一致）。
        // 例如初次加载时父组件才从 localStorage 加载用户列偏好，此时需要重建才能生效。
        // 组件首次挂载前的 immediate 同步不做强制重建，避免无意义的重渲染。
        if (changed && this._columnsRendered) {
          this.tableRenderKey++;
          this.$nextTick(() => {
            this.doTableLayout();
            // 强制重建后 DOM 被替换，需重新初始化列拖拽排序与列宽调节
            this.$nextTick(() => {
              if (this.columnDraggable) this.initColumnDrag();
              if (this.columnResizable) this.initColumnResize();
            });
          });
        }
      }
    }
  },
  // ✅ 多选列切换（批量操作）：动态增删 selection 列后 el-table 不会自动刷新列布局，
  // 必须通过 tableRenderKey++ 强制完全重渲染，否则多选框不会出现
  showSelection() {
    if (this._columnsRendered) {
      // 记录当前客户端排序状态，整表重建后恢复，避免切换多选列把用户排好的顺序重置成默认
      const oldTable = this.$refs.refTable;
      let sortProp = '';
      let sortOrder = '';
      if (oldTable && oldTable.store && oldTable.store.states) {
        sortProp = oldTable.store.states.sortProp || '';
        sortOrder = oldTable.store.states.sortOrder || '';
      }
      this.tableRenderKey++;
      this.$nextTick(() => {
        this.doTableLayout();
        this.$nextTick(() => {
          if (this.columnDraggable) this.initColumnDrag();
          if (this.columnResizable) this.initColumnResize();
          // 重建完成后再把用户之前设置的排序应用回去
          if (sortProp && sortOrder) {
            const newTable = this.$refs.refTable;
            if (newTable && typeof newTable.sort === 'function') {
              newTable.sort(sortProp, sortOrder);
              newTable.$nextTick(() => this.doTableLayout());
            }
          }
        });
      });
    }
  },
  // ✅ 数据变化时重新布局，修复固定列偏移
  tableData: {
    handler() {
      this.$nextTick(() => {
        this.doTableLayout();
      });
    },
    deep: true
  },
  // ✅ 从父组件同步列筛选值到内部 filterValues，保持漏斗图标实心状态
  columnFilterValues: {
    deep: true,
    handler(val) {
      // 先清空旧值，避免已清除列筛选的字段残留
      Object.keys(this.filterValues).forEach(k => this.$delete(this.filterValues, k));
      // 再用 $set 逐个写入新值，确保 Vue 响应式
      if (val) {
        Object.keys(val).forEach(k => this.$set(this.filterValues, k, val[k]));
      }
    }
  },
  // ✅ loading 结束也触发
  loading(val) {
    if (!val) {
      this.$nextTick(() => {
        this.doTableLayout();
      });
    }
  }
},

created() {
  // ✅ 从父组件同步列筛选值到 filterValues，用 $set 确保 Vue 响应式
  const vals = this.columnFilterValues || {};
  Object.keys(vals).forEach(k => {
    if (vals[k]) {
      this.$set(this.filterValues, k, vals[k]);
    }
  });
  // 绑定列宽调整的事件处理函数（保持正确的 this 引用）
  this._boundResizeMove = (e) => this._onResizeMove(e);
  this._boundResizeEnd = () => this._onResizeEnd();
},

mounted() {
  // 标记组件已完成首次渲染，后续 tableColumn 变化时强制重建 el-table 以应用列配置
  this._columnsRendered = true;
  // ✅ 监听表格主体滚动，同步修复固定列偏移
  this.$nextTick(() => {
    this.bindScrollFix();
    if (this.columnDraggable) {
      // 延迟确保 Element UI 表格完全渲染
      setTimeout(() => {
        this.initColumnDrag();
      }, 300);
    }
    if (this.columnResizable) {
      setTimeout(() => {
        this.initColumnResize();
      }, 400);
    }
  });
},

beforeDestroy() {
  this.unbindScrollFix();
  this.destroyColumnDrag();
  this.destroyColumnResize();
},

methods: {
  // ==================== 列拖拽排序 ====================
  /** 计算表头中数据列之前的偏移量（如序号列、展开列） */
  getColumnDragOffset() {
    const table = this.$refs.refTable;
    if (!table) return 0;
    const headerWrapper = table.$el.querySelector('.el-table__header-wrapper');
    if (!headerWrapper) return 0;
    const tr = headerWrapper.querySelector('thead tr');
    if (!tr) return 0;

    // 排除 Element UI 的 gutter 列（滚动条占位，class="gutter"）
    // 排除 display:none 的列
    const visibleThs = [...tr.querySelectorAll('th')].filter(th => {
      if (th.style.display === 'none') return false;
      if (th.classList.contains('gutter')) return false;
      return true;
    });

    return visibleThs.length - this.finalColumns.length;
  },

  /** 初始化列头拖拽 */
  initColumnDrag() {
    this.destroyColumnDrag();
    if (!this.columnDraggable) return;

    const table = this.$refs.refTable;
    if (!table) return;
    const headerWrapper = table.$el.querySelector('.el-table__header-wrapper');
    if (!headerWrapper) return;
    const headerRow = headerWrapper.querySelector('thead tr');
    if (!headerRow) return;

    const that = this;
    this.sortableInstance = Sortable.create(headerRow, {
      animation: 150,
      handle: 'th',
      draggable: 'th',
      filter: '.column-resize-handle',    // 排除列宽拖拽手柄区域，避免冲突
      preventOnFilter: false,             // 不阻止 filter 元素的默认事件，让 resize 手柄正常工作
      ghostClass: 'column-drag-ghost',
      chosenClass: 'column-drag-chosen',
      forceFallback: true,
      fallbackOnBody: true,

      onMove(evt) {
        // 禁止拖拽展开列
        if (evt.dragged.classList.contains('el-table__expand-column')) return false;
        if (evt.related.classList.contains('el-table__expand-column')) return false;
        // 禁止拖拽 gutter 列（滚动条占位）
        if (evt.dragged.classList.contains('gutter')) return false;
        if (evt.related.classList.contains('gutter')) return false;
        // 禁止将数据列拖拽到序号列之前
        const children = [...evt.from.children];
        const draggedIdx = children.indexOf(evt.dragged);
        const relatedIdx = children.indexOf(evt.related);
        const offset = that.getColumnDragOffset();
        const allow = draggedIdx >= offset && relatedIdx >= offset;
        return allow;
      },

      onEnd(evt) {
        const { oldIndex, newIndex } = evt;
        if (oldIndex === undefined || newIndex === undefined || oldIndex === newIndex) return;

        const offset = that.getColumnDragOffset();
        const oldColIndex = oldIndex - offset;
        const newColIndex = newIndex - offset;

        // 使用 finalColumns（实际渲染的列）来定位拖动的目标，而非直接引用 internalColumns
        // 在手机模式下 finalColumns 是 internalColumns 的子集，直接用 Sortable 的索引会导致错位
        const fc = that.finalColumns;
        if (oldColIndex < 0 || newColIndex < 0) return;
        if (oldColIndex >= fc.length || newColIndex >= fc.length) return;

        // 通过 prop 定位被拖拽的列和目标列在 internalColumns 中的真实位置
        const movedProp = fc[oldColIndex].prop;
        const internalOldIdx = that.internalColumns.findIndex(c => c.prop === movedProp);
        const targetProp = fc[newColIndex].prop;
        let internalNewIdx = that.internalColumns.findIndex(c => c.prop === targetProp);

        if (internalOldIdx < 0 || internalNewIdx < 0) return;

        // 移动列：从 internalOldIdx 位置取出
        const movedItem = that.internalColumns.splice(internalOldIdx, 1)[0];

        // 如果 oldColIndex > newColIndex（往左拖），插入到目标之前
        // 如果 oldColIndex < newColIndex（往右拖），插入到目标之后
        if (oldColIndex > newColIndex) {
          // 往左拖：插入到目标列之前，无需调整索引
        } else {
          // 往右拖：插入到目标列之后，splice 已删除一项，目标位置需 +1
          internalNewIdx++;
        }
        // 如果删除位置在插入位置之前，插入位置需 -1
        if (internalNewIdx > internalOldIdx) internalNewIdx--;

        that.internalColumns.splice(internalNewIdx, 0, movedItem);
        that.columnUserReordered = true;
        // 强制 el-table 完全重渲染
        that.tableRenderKey++;

        that.$emit('column-order-change', [...that.internalColumns]);

        // 等待 el-table 重新渲染完成后再绑定拖拽和列宽调节
        that.$nextTick(() => {
          that.$nextTick(() => {
            that.initColumnDrag();
            that.initColumnResize();
          });
        });
      }
    });
  },

  /** 销毁列拖拽实例 */
  destroyColumnDrag() {
    if (this.sortableInstance) {
      this.sortableInstance.destroy();
      this.sortableInstance = null;
    }
  },

  // ==================== 列宽拖拽调整 ====================
  /** 初始化列宽拖拽 */
  initColumnResize() {
    this.destroyColumnResize();
    if (!this.columnResizable) return;

    const table = this.$refs.refTable;
    if (!table) return;
    const headerWrapper = table.$el.querySelector('.el-table__header-wrapper');
    if (!headerWrapper) return;
    const headerRow = headerWrapper.querySelector('thead tr');
    if (!headerRow) return;

    const that = this;
    const offset = this.getColumnDragOffset();
    const ths = headerRow.querySelectorAll('th');

    ths.forEach((th, index) => {
      // 跳过 gutter（滚动条占位）、隐藏列
      if (th.classList.contains('gutter')) return;
      if (th.style.display === 'none') return;

      const colIndex = index - offset;
      if (colIndex < 0 || colIndex >= this.internalColumns.length) return;

      // 不重复添加手柄
      if (th.querySelector('.column-resize-handle')) return;

      const handle = document.createElement('div');
      handle.className = 'column-resize-handle';
      handle.addEventListener('mousedown', (e) => {
        that._onResizeStart(e, th, colIndex);
      });
      th.appendChild(handle);
    });

    this.resizeBound = true;
  },

  /** 开始拖拽调整列宽 */
  _onResizeStart(e, th, colIndex) {
    e.preventDefault();
    e.stopPropagation();

    const table = this.$refs.refTable;
    if (!table) return;

    // 重新计算 offset（列可能已被隐藏/显示过）
    const offset = this.getColumnDragOffset();

    // 收集该列所有表体 td 单元格（拖拽期间同步更新宽度）
    const bodyCells = this._collectBodyCellsByColumn(colIndex, offset, table);

    this.columnResizeData = {
      startX: e.clientX,
      startWidth: th.getBoundingClientRect().width,
      colIndex,
      th,
      offset,
      bodyCells,
      bodyWrapper: table.$el.querySelector('.el-table__body-wrapper'),
      colgroup: table.$el.querySelector('colgroup')
    };

    document.addEventListener('mousemove', this._boundResizeMove);
    document.addEventListener('mouseup', this._boundResizeEnd);
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
  },

  /** 拖拽中 */
  _onResizeMove(e) {
    const data = this.columnResizeData;
    if (!data) return;

    const { startX, startWidth, colIndex, th, offset, colgroup, bodyCells } = data;
    const delta = e.clientX - startX;
    const newWidth = Math.max(40, startWidth + delta);

    // 实时更新 th（表头）
    th.style.width = newWidth + 'px';
    th.style.minWidth = newWidth + 'px';

    // 同步更新所有表体 td 单元格宽度
    if (bodyCells) {
      bodyCells.forEach(cell => {
        cell.style.width = newWidth + 'px';
        cell.style.minWidth = newWidth + 'px';
      });
    }

    // 同步更新 colgroup 中的 col 宽度（保证表体和表头对齐）
    if (colgroup) {
      const cols = colgroup.querySelectorAll('col');
      const colGroupIndex = colIndex + offset;
      if (cols[colGroupIndex]) {
        cols[colGroupIndex].style.width = newWidth + 'px';
      }
    }
  },

  /** 拖拽结束，持久化宽度 */
  _onResizeEnd() {
    document.removeEventListener('mousemove', this._boundResizeMove);
    document.removeEventListener('mouseup', this._boundResizeEnd);
    document.body.style.cursor = '';
    document.body.style.userSelect = '';

    const data = this.columnResizeData;
    if (!data) return;

    const { colIndex, th } = data;
    const finalWidth = Math.round(th.getBoundingClientRect().width);

    if (this.internalColumns[colIndex]) {
      const col = this.internalColumns[colIndex];
      // 设置 width（link、操作栏、普通文本列使用）
      this.$set(col, 'width', finalWidth);
      // 设置 minWidth（普通文本列的 fallback，以及只有 min-width 绑定的列）
      this.$set(col, 'minWidth', finalWidth);
      // 设置嵌套 column.width（progress、dateEdit、textEdit 列使用）
      if (col.column && typeof col.column === 'object') {
        this.$set(col.column, 'width', finalWidth);
      }
      // 强制 Vue 重新渲染表格以应用新宽度
      this.tableRenderKey++;

      // 通知父组件列宽已变更（用于持久化保存）
      this.$emit('column-width-change', { prop: col.prop, width: finalWidth });
    }
    this.columnResizeData = null;

    // 强制 el-table 重新布局，并重新挂载拖拽手柄和列排序
    this.$nextTick(() => {
      this.doTableLayout();
      // tableRenderKey++ 导致 DOM 重建，需要重新初始化列拖拽排序和列宽调节
      this.$nextTick(() => {
        this.initColumnDrag();
        this.initColumnResize();
      });
    });
  },

  /** 收集指定列的所有表体 td 单元格 */
  _collectBodyCellsByColumn(colIndex, offset, table) {
    const cells = [];
    // 从主体 tbody 中查找该列所有 td
    const bodyWrapper = table.$el.querySelector('.el-table__body-wrapper');
    if (!bodyWrapper) return cells;
    const rows = bodyWrapper.querySelectorAll('tbody tr');
    const colGroupIndex = colIndex + offset;
    rows.forEach(row => {
      const tds = row.querySelectorAll('td');
      if (tds[colGroupIndex]) {
        cells.push(tds[colGroupIndex]);
      }
    });
    return cells;
  },

  /** 销毁列宽拖拽 */
  destroyColumnResize() {
    document.removeEventListener('mousemove', this._boundResizeMove);
    document.removeEventListener('mouseup', this._boundResizeEnd);

    const table = this.$refs.refTable;
    if (table && table.$el) {
      const handles = table.$el.querySelectorAll('.column-resize-handle');
      handles.forEach(h => h.remove());
    }
    this.resizeBound = false;
    this.columnResizeData = null;
  },

  // ✅ 强制重新布局固定列
  doTableLayout() {
    const table = this.$refs.refTable;
    if (table && table.doLayout) {
      table.doLayout();
    }
  },

  // ✅ 监听滚动事件，实时修正固定列偏移
  bindScrollFix() {
    const table = this.$refs.refTable;
    if (!table) return;
    const bodyWrapper = table.$el.querySelector('.el-table__body-wrapper');
    if (!bodyWrapper) return;
    this._scrollTarget = bodyWrapper;
    this._scrollHandler = () => {
      // 使用 requestAnimationFrame 避免频繁调用 doLayout
      if (this._scrollRAF) return;
      this._scrollRAF = requestAnimationFrame(() => {
        this._scrollRAF = null;
        this.doTableLayout();
      });
    };
    bodyWrapper.addEventListener('scroll', this._scrollHandler);
  },

  unbindScrollFix() {
    if (this._scrollTarget && this._scrollHandler) {
      this._scrollTarget.removeEventListener('scroll', this._scrollHandler);
    }
    this._scrollTarget = null;
    this._scrollHandler = null;
    if (this._scrollRAF) {
      cancelAnimationFrame(this._scrollRAF);
      this._scrollRAF = null;
    }
  },
  // ✅ 新增日期编辑相关方法
  setDateEditRef(index, el) {
    if (el) this.$set(this.dateEditRefs, index, el);
  },

  handleDateEditClick(row, columnItem, index) {
    // 打开日期编辑弹窗
    this.$set(this.dateEditValues, index, row[columnItem.column.field] || '');
    this.$set(this.dateEditVisible, index, true);

    this.$nextTick(() => {
      // 日期选择器不需要手动聚焦
    });

    this.$emit('dateEditClick', {
      row,
      column: columnItem,
      index,
      value: row[columnItem.column.field],
      prop: columnItem.prop,
      field: columnItem.column.field
    });
  },

  saveDateEdit(row, columnItem, index) {
    this.$set(this.dateEditVisible, index, false);
    this.$emit('dateEditSave', {
      row,
      column: columnItem,
      index,
      value: this.dateEditValues[index],
      prop: columnItem.prop,
      field: columnItem.column.field
    });
  },

  cancelDateEdit(index) {
    this.$set(this.dateEditVisible, index, false);
  },




  setTextEditRef(index, el) {
    if (el) this.$set(this.textEditRefs, index, el);
  },

  // 文本编辑列是否可编辑：column.editable === false 表示仅查看
  isTextEditEditable(columnItem) {
    const col = columnItem && columnItem.column;
    return !col || col.editable !== false;
  },

  handleTextEditClick(row, columnItem, index) {
    if (!this.isTextEditEditable(columnItem)) return;

    this.$set(this.textEditValues, index, row[columnItem.column.field] || '');
    this.$set(this.textEditVisible, index, true);

    this.$nextTick(() => {
      this.textEditRefs[index].focus();
    });

    this.$emit('textEditClick', {
      row,
      column: columnItem,
      index,
      value: row[columnItem.column.field],
      prop: columnItem.prop,
      field: columnItem.column.field
    });
  },

  saveTextEdit(row, columnItem, index) {
    this.$set(this.textEditVisible, index, false);
    this.$emit('textEditSave', {
      row,
      column: columnItem,
      index,
      value: this.textEditValues[index],
      prop: columnItem.prop,
      field: columnItem.column.field
    });
  },

  cancelTextEdit(index) {
    this.$set(this.textEditVisible, index, false);
  },




  /**
   * 关键字「不包含」筛选：值统一存放在 filterValues[prop + '__not']，
   * 与「包含」关键字一起随 column-filter-change 事件回传给父组件
   */
  notFilterProp(prop) {
    return prop + '__not';
  },

  /** 漏斗图标是否点亮：包含关键字或不包含关键字任意一个有值即点亮 */
  hasFilterValue(prop) {
    return !!(this.filterValues[prop] || this.filterValues[this.notFilterProp(prop)]);
  },

  onNotFilterInput(prop, val) {
    // 用 $set 写入，保证新增 key 也具备响应式
    this.$set(this.filterValues, this.notFilterProp(prop), val || '');
  },

  onNotFilterClear(prop) {
    this.$set(this.filterValues, this.notFilterProp(prop), '');
    this.$emit('column-filter-change', this.filterValues);
  },

  confirmFilter(prop) {
    this.$set(this.filterVisible, prop, false);
    this.currentFilterProp = '';
    this.$emit('column-filter-change', this.filterValues);
  },

toggleFilter(prop, filterType) {
  // ✅ 如果点在同一个字段，直接关闭
  if (this.currentFilterProp === prop) {
    this.$set(this.filterVisible, prop, false);
    this.currentFilterProp = '';
    return;
  }

  // ✅ 关闭上一个（包括普通和时间）
  if (this.currentFilterProp) {
    this.$set(this.filterVisible, this.currentFilterProp, false);
    this.$set(this.dateFilterVisible, this.currentFilterProp, false); // ✅ 关键
  }

  // ✅ 打开当前
  this.$set(this.filterVisible, prop, true);
  this.currentFilterProp = prop;

  // ✅ 回填已生效的筛选值（dateSelect 走的是 filterVisible，也在这里回填）
  this.syncFilterValueToEditor(prop, filterType);

  this.$nextTick(() => {
    if (this.filterInputRefs[prop]) {
      this.filterInputRefs[prop].focus();
    }
  });
},

  clearColumnFilter(prop) {
    this.$set(this.filterValues, prop, '');
    // 同时清掉该列的「不包含」关键字，避免残留
    this.$set(this.filterValues, this.notFilterProp(prop), '');
    this.$set(this.filterVisible, prop, false);
    this.currentFilterProp = '';
    this.$emit('column-filter-change', this.filterValues);
  },

  /** ✅ 清空当前列的筛选条件（date / dateFrom / dateEqual / dateSelect / 关键字通用），立即生效
   *  ⚠️ 除了清 filterValues，还要清各类型编辑器的「临时值」——
   *     否则下次打开弹层时 syncFilterValueToEditor 虽然会回填，但残留的旧临时值
   *     可能让日期选择器看起来还留着上次的条件。 */
  clearCurrentFilter(prop) {
    this.$set(this.filterValues, prop, '');
    this.$set(this.filterValues, this.notFilterProp(prop), '');

    this.$set(this.dateFilterValues, prop, null);
    this.$set(this.dateFromFilterValues, prop, '');
    this.$set(this.dateEqualFilterValues, prop, '');
    this.$set(this.dateSelectRange, prop, null);
    this.$set(this.dateSelectType, prop, 'all');
    this.$set(this.dateSelectPickerVisible, prop, false);

    this.$set(this.filterVisible, prop, false);
    this.$set(this.dateFilterVisible, prop, false);
    this.currentFilterProp = '';
    this.$emit('column-filter-change', this.filterValues);
  },

  /** ✅ 打开筛选弹层时，把「已生效的筛选值」回填到对应的编辑器
   *  以前打开弹层是空白的，用户看不到自己上次设的是什么条件。 */
  syncFilterValueToEditor(prop, filterType) {
    const val = this.filterValues[prop];

    if (filterType === 'date') {
      this.$set(this.dateFilterValues, prop,
        Array.isArray(val) && val.length === 2 ? val.slice() : null);
    } else if (filterType === 'dateFrom') {
      this.$set(this.dateFromFilterValues, prop, val || '');
    } else if (filterType === 'dateEqual') {
      this.$set(this.dateEqualFilterValues, prop, val || '');
    } else if (filterType === 'dateSelect') {
      const range = Array.isArray(val) && val.length === 2 ? val.slice() : null;
      this.$set(this.dateSelectRange, prop, range);
      // 没记住快捷类型时：有区间按「自定义」回显，没有则「所有」
      if (!this.dateSelectType[prop]) {
        this.$set(this.dateSelectType, prop, range ? 'custom' : 'all');
      }
    }
  },

  /** ✅ 点日期输入框自带的 ×（clearable 图标）时触发
   *  Element 的 @clear 默认只是把 v-model 清空，筛选值要等点「确定」才提交；
   *  这里直接走一次完整清空并 emit，做到点 × 就生效、不用再点确定。
   *  适用于 date / dateFrom / dateEqual / dateSelect 四种日期筛选。 */
  onDatePickerClear(prop) {
    this.clearCurrentFilter(prop);
  },

  /** ✅ 当前筛选条件的文字摘要（显示在弹层里）
   *  日期区间 →「2026-01-01 至 2026-12-31」；单值 → 原样；无 → ''（不显示这一行） */
  filterSummary(prop) {
    const val = this.filterValues[prop];
    if (Array.isArray(val)) {
      if (val.length === 2 && (val[0] || val[1])) {
        return `${val[0] || '不限'} 至 ${val[1] || '不限'}`;
      }
      return '';
    }
    if (val === undefined || val === null || val === '') return '';
    return String(val);
  },
cancelFilter(prop) {
  this.$set(this.filterVisible, prop, false);
  this.$set(this.dateFilterVisible, prop, false); // ✅
  this.currentFilterProp = '';
},

cancelDateFilter(prop) {
  this.$set(this.filterVisible, prop, false); // ✅
  this.$set(this.dateFilterVisible, prop, false);
  this.currentFilterProp = '';
},

// ==================== dateSelect 相关方法 ====================

setDateSelectPickerRef(prop, el) {
  if (el) this.$set(this.dateSelectPickerRefs, prop, el);
},

handleDateSelectTypeChange(prop) {
  const type = this.dateSelectType[prop];
  if (type === 'custom') {
    // ✅ 延迟打开，等 select 下拉关闭
    setTimeout(() => {
      this.openDateSelectPicker(prop);
    }, 150);
  } else {
    this.$set(this.dateSelectPickerVisible, prop, false);
    this.setDateSelectRange(prop, type);
  }
},

handleDateSelectVisibleChange(prop, visible) {
  // ✅ 只有当 select 下拉关闭后、且当前为 custom 时，才打开日期选择器
  // 避免与 @change 重复触发
  if (visible) return;
  if (this.dateSelectType[prop] === 'custom') {
    // ✅ 延迟一点等 select 下拉完全关闭
    setTimeout(() => {
      this.openDateSelectPicker(prop);
    }, 150);
  }
},

openDateSelectPicker(prop) {
  this.$set(this.dateSelectType, prop, 'custom');
  this.$set(this.dateSelectPickerVisible, prop, true);

  // ✅ 等两个 tick：第一个 tick 让 v-if 创建元素，第二个 tick 让 ref 赋值完成
  this.$nextTick(() => {
    this.$nextTick(() => {
      const picker = this.dateSelectPickerRefs[prop];
      const el = picker && picker.$el;
      if (!el) return;

      // ✅ 定位到当前可见的 column-filter-popover 弹框紧挨着的下方
      const popovers = document.querySelectorAll('.column-filter-popover');
      let popover = null;
      popovers.forEach(p => {
        if (p.style.display !== 'none') {
          popover = p;
        }
      });
      if (!popover) return;

      const rect = popover.getBoundingClientRect();
      // 直接设置 style 属性，并用 cssText 确保生效
      el.style.cssText = `
        position: fixed !important;
        top: ${rect.bottom + 4}px !important;
        left: ${rect.left}px !important;
        z-index: 3000 !important;
        opacity: 1 !important;
        pointer-events: auto !important;
        width: 240px;
      `;

      // ✅ 手动触发 date-picker 的 focus 打开面板
      if (picker.focus) {
        picker.focus();
      }
    });
  });
},

setDateSelectRange(prop, type) {
  const now = new Date();
  let start = null;
  let end = null;

  switch (type) {
    case 'year':
      start = new Date(now.getFullYear(), 0, 1);
      end = now;
      break;
    case 'month':
      start = new Date(now.getFullYear(), now.getMonth(), 1);
      end = now;
      break;
    case 'week': {
      const day = now.getDay() || 7;
      start = new Date(now);
      start.setDate(now.getDate() - day + 1);
      end = new Date(start);
      end.setDate(start.getDate() + 6);
      break;
    }
    case 'all':
    default:
      this.$set(this.dateSelectRange, prop, []);
      this.$set(this.filterValues, prop, '');
      return;
  }

  const range = [
    this.formatDateSelect(start),
    this.formatDateSelect(end)
  ];
  this.$set(this.dateSelectRange, prop, range);
  this.$set(this.filterValues, prop, range);
},

formatDateSelect(date) {
  if (!date || isNaN(date.getTime())) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
},

handleDateSelectRangeChange(prop) {
  const range = this.dateSelectRange[prop];
  if (range && range.length === 2) {
    this.$set(this.filterValues, prop, range);
  } else {
    // ✅ 清空（点 × 或删空）→ 直接清掉该列筛选并立即生效，不用再点「确定」
    //   （原来只是把 filterValues 置空，但没 emit、也没关弹层，所以还得点确定）
    this.clearCurrentFilter(prop);
  }
},

confirmDateSelectFilter(prop) {
  // 关闭 popover
  this.$set(this.filterVisible, prop, false);
  this.currentFilterProp = '';
  // filterValues 已经在 setDateSelectRange/handleDateSelectRangeChange 中设置好了
  this.$emit('column-filter-change', this.filterValues);
},

// ==================== dateSelect 相关方法结束 ====================




  // ✅ 打开时间筛选
toggleDateFilter(prop, filterType) {
  // ✅ 如果点在同一个字段，直接关闭
  if (this.currentFilterProp === prop) {
    this.$set(this.dateFilterVisible, prop, false);
    this.currentFilterProp = '';
    return;
  }

  // ✅ 关闭上一个（包括普通和时间）
  if (this.currentFilterProp) {
    this.$set(this.filterVisible, this.currentFilterProp, false); // ✅ 关键
    this.$set(this.dateFilterVisible, this.currentFilterProp, false);
  }

  // ✅ 打开当前
  this.$set(this.dateFilterVisible, prop, true);
  this.currentFilterProp = prop;

  // ✅ 回填已生效的筛选值（date / dateFrom / dateEqual 走的是 dateFilterVisible）
  this.syncFilterValueToEditor(prop, filterType);

  this.$nextTick(() => {
    if (this.dateFilterRefs[prop]) {
      this.dateFilterRefs[prop].focus();
    }
  });
},

  // ✅ 日期变化
  handleDateFilterChange(prop) {
    // ⚠️ 这个钩子原来是个空函数（连 prop 都没接），所以点输入框自带的 × 时
    //    只是把 v-model 清空了，筛选值一直没变，必须再点「确定」才生效。
    //    这里改成：值被清空（点 × 或手动删空）→ 直接清掉该列筛选并立即生效。
    const range = this.dateFilterValues[prop];
    if (!range || range.length === 0 || (!range[0] && !range[1])) {
      this.clearCurrentFilter(prop);
    }
  },

  // ✅ 确认时间筛选
confirmDateFilter(prop) {
  this.$set(this.dateFilterVisible, prop, false);
  this.currentFilterProp = '';

  // ✅ 关键修复：检查日期范围是否有效
  const dateRange = this.dateFilterValues[prop];
  
  // ✅ 只有当日期范围有效时才设置，否则设为空字符串
  if (Array.isArray(dateRange) && dateRange.length === 2) {
    this.$set(this.filterValues, prop, dateRange);
  } else {
    // ✅ 无效的日期范围，设为空字符串
    this.$set(this.filterValues, prop, '');
  }

  this.$emit('column-filter-change', this.filterValues);
},



  // ✅ 清空时间筛选
  clearDateFilter(prop) {
    this.$set(this.dateFilterValues, prop, []);
    this.$set(this.filterValues, prop, []);
    this.$emit('column-filter-change', this.filterValues);
  },

  // ==================== dateFrom 相关方法 ====================

  // ✅ dateFrom 变化
  handleDateFromFilterChange(prop) {
    // ✅ 清空（点 × 或删空）→ 直接生效，不用再点「确定」
    if (!this.dateFromFilterValues[prop]) {
      this.clearCurrentFilter(prop);
    }
  },

  // ✅ 确认 dateFrom 筛选（单日期，不早于）
  confirmDateFromFilter(prop) {
    this.$set(this.dateFilterVisible, prop, false);
    this.currentFilterProp = '';

    const dateVal = this.dateFromFilterValues[prop];
    if (dateVal) {
      this.$set(this.filterValues, prop, dateVal);
    } else {
      this.$set(this.filterValues, prop, '');
    }

    this.$emit('column-filter-change', this.filterValues);
  },

  // ✅ 清空 dateFrom 筛选
  clearDateFromFilter(prop) {
    this.$set(this.dateFromFilterValues, prop, null);
    this.$set(this.filterValues, prop, '');
    this.$emit('column-filter-change', this.filterValues);
  },

  // ==================== dateEqual 相关方法 ====================

  // ✅ dateEqual 变化
  handleDateEqualFilterChange(prop) {
    // ✅ 清空（点 × 或删空）→ 直接生效，不用再点「确定」
    if (!this.dateEqualFilterValues[prop]) {
      this.clearCurrentFilter(prop);
    }
  },

  // ✅ 确认 dateEqual 筛选（单日期，筛选所选日期当天）
  confirmDateEqualFilter(prop) {
    this.$set(this.dateFilterVisible, prop, false);
    this.currentFilterProp = '';

    const dateVal = this.dateEqualFilterValues[prop];
    if (dateVal) {
      this.$set(this.filterValues, prop, dateVal);
    } else {
      this.$set(this.filterValues, prop, '');
    }

    this.$emit('column-filter-change', this.filterValues);
  },

  // ✅ 清空 dateEqual 筛选
  clearDateEqualFilter(prop) {
    this.$set(this.dateEqualFilterValues, prop, null);
    this.$set(this.filterValues, prop, '');
    this.$emit('column-filter-change', this.filterValues);
  },


  // 处理重置密码点击
  handleResetPasswordClick(row, columnItem, index) {
    // 触发重置密码点击事件
    this.$emit('resetPasswordClick', {
      row: row,                    // 当前行的完整数据
      column: columnItem,          // 列配置信息
      index: index,                // 行索引
      userId: row.id || row.userId, // 用户ID
      username: row.username       // 用户名
    });
    
    // 如果需要，也可以直接触发指定名称的事件
    if (columnItem.column.eventName) {
      this.$emit(columnItem.column.eventName, {
        row: row,
        column: columnItem,
        index: index,
        userId: row.id || row.userId,
        username: row.username
      });
    }
  },

  // handleDateEditClick(row, columnItem, index) {
  //   // 触发日期编辑点击事件
  //   this.$emit('dateEditClick', {
  //     row: row,                    // 当前行的完整数据
  //     column: columnItem,          // 列配置信息
  //     index: index,                // 行索引
  //     value: row[columnItem.column.field],  // 当前日期值
  //     prop: columnItem.prop,       // 字段名称
  //     field: columnItem.column.field  // 数据字段
  //   });
  // },

  // 格式化日期显示
  formatDateDisplay(dateValue, dateFormat) {
    if (!dateValue) return '';
    
    // 如果指定了自定义格式化函数
    if (dateFormat && typeof dateFormat === 'function') {
      return dateFormat(dateValue);
    }
    
    // 默认处理：如果是长日期字符串，只取前10位（yyyy-MM-dd）
    if (typeof dateValue === 'string' && dateValue.length > 10) {
      return dateValue.substring(0, 10);
    }
    
    return dateValue;
  },

  // 处理文字编辑点击
  // handleTextEditClick(row, columnItem, index) {
  //   // 触发文字编辑点击事件
  //   this.$emit('textEditClick', {
  //     row: row,                    // 当前行的完整数据
  //     column: columnItem,          // 列配置信息
  //     index: index,                // 行索引
  //     value: row[columnItem.column.field],  // 当前文本值
  //     prop: columnItem.prop,       // 字段名称
  //     field: columnItem.column.field  // 数据字段
  //   });
  // },
  
  // 格式化文本显示
  formatTextDisplay(textValue, maxLength) {
    if (!textValue) return '';
    
    // 如果指定了最大显示长度
    if (maxLength && textValue.length > maxLength) {
      return textValue.substring(0, maxLength) + '...';
    }
    
    return textValue;
  },       

  // 处理评审进度链接点击
  handleReviewLinkClick(row, columnItem) {
    // 如果已经加载过，不再重复请求
    if (row._reviewParticipants !== undefined || row._reviewLoading) return;
    row._reviewLoading = true;
    // 触发事件到父组件，由父组件调用接口
    if (columnItem.column.eventName) {
      this.$emit(columnItem.column.eventName, {
        row: row,
        column: columnItem,
        value: row[columnItem.column.field]
      });
    }
  },

  /** ✅ 操作列（actions）的行级启用判断
   *  列配置：{ prop:'操作', actions:[...], actionEnabledField:'售后总数量' }
   *  —— 该字段「没有值」时（0 / '0' / 空 / 纯空格 / null / undefined），操作列渲染成
   *     普通黑色文本、不可点击；有值才渲染成可点的文字按钮。
   *     逻辑与评审进度列一致：评审进度只有「暂存」是可点链接，其余是普通文本。
   *  ⚠️ 不配 actionEnabledField 时恒返回 true，对现有所有操作列零影响。 */
  isActionEnabled(row, item) {
    const field = item && item.actionEnabledField;
    if (!field || !row) return true;
    const v = row[field];
    const s = (v === null || v === undefined) ? '' : String(v).trim();
    return !(s === '' || s === '0');
  },

  /** ✅ 链接列的行级禁用判断
   *  支持两种模式（白名单优先）：
   *  1) 白名单：column: { type:'link', enabledField:'物料属性', enabledValues:['自制'] }
   *     —— 只有「物料属性 = 自制」才可点，外购 / 空 / 其它值一律渲染成普通文本且点击无响应。
   *  2) 黑名单：column: { type:'link', disabledField:'物料属性', disabledValues:['外购'] }
   *     —— 命中的行不可点（兼容旧配置）。
   *  ⚠️ 两个都没配时恒返回 false，对现有所有 link 列零影响。
   *  ⚠️ 取值统一 trim，避免后端传 ' 自制 ' 这类带空格的值导致误判。 */
  isLinkDisabled(row, columnItem) {
    const cfg = (columnItem && columnItem.column) || {};
    if (!row) return false;

    const normalize = v => (v === undefined || v === null ? '' : String(v).trim());

    // 白名单模式：只有列在 enabledValues 里的值才允许点击
    if (cfg.enabledField) {
      return (cfg.enabledValues || []).indexOf(normalize(row[cfg.enabledField])) === -1;
    }

    // 黑名单模式
    if (!cfg.disabledField) return false;
    return (cfg.disabledValues || []).indexOf(normalize(row[cfg.disabledField])) !== -1;
  },

  // 处理链接点击事件
  handleLinkClick(row, columnItem) {
    // ✅ 行级禁用的行：不派发任何事件（外观已是普通文本，点击也不该有反应）
    if (this.isLinkDisabled(row, columnItem)) return;

    // 触发一个自定义事件，将行数据和列配置信息传递给父组件
    this.$emit('linkClick', {
      row: row,                    // 当前行的完整数据
      column: columnItem,          // 列配置信息
      value: this.getLinkText(row, columnItem)  // 链接显示的文本
    });
    
    // 如果列配置中指定了自定义事件名称，也触发该事件
    if (columnItem.column.eventName) {
      this.$emit(columnItem.column.eventName, {
        row: row,
        column: columnItem,
        value: this.getLinkText(row, columnItem)
      });
    }
  },
  
  // 获取链接显示的文本
  getLinkText(row, columnItem) {
    // 优先使用 column.field 指定的字段
    if (columnItem.column.field && row[columnItem.column.field] !== undefined) {
      return row[columnItem.column.field];
    }
    // 回退到使用 prop 字段
    if (row[columnItem.prop] !== undefined) {
      return row[columnItem.prop];
    }
    return '';
  },
  
  // 获取链接的样式
  getLinkStyle(columnConfig) {
    const style = {
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      textDecoration: 'none',
      fontWeight: 'normal',
      display: 'inline-block'
    };
    
    // 从列配置中获取样式，如果没有则使用默认蓝色
    if (columnConfig.linkStyle) {
      Object.assign(style, columnConfig.linkStyle);
    } else {
      // 默认蓝色链接样式
      style.color = '#2564CFCC';
    }
    
    return style;
  },



  // 处理开关状态变化
  handleSwitchChange(row, columnItem, index) {
    // 触发一个自定义事件，将变化的数据传递给父组件
    this.$emit('switchChange', {
      row: row,                    // 当前行的完整数据
      column: columnItem,          // 列配置信息
      index: index,                // 行索引
      value: row[columnItem.column.field],  // 当前开关的值
      prop: columnItem.prop,       // 字段名称
      field: columnItem.column.field  // 数据字段
    });
    
    // 如果需要，也可以直接触发指定名称的事件
    if (columnItem.column.eventName) {
      this.$emit(columnItem.column.eventName, {
        row: row,
        column: columnItem,
        index: index,
        value: row[columnItem.column.field],
        prop: columnItem.prop,
        field: columnItem.column.field
      });
    }
  },


  
  // 获取图标悬停提示文字
  getIconTooltip(row, tooltipField) {
    if (!row || !tooltipField) {
      return '暂无信息';
    }
    const tooltipValue = row[tooltipField];
    // 如果状态详情字段有值，则显示；否则显示一个默认提示
    if (tooltipValue !== null && tooltipValue !== undefined && tooltipValue !== '') {
      return tooltipValue;
    }
    return '暂无状态详情';
  },

  // 根据状态码获取对应的CSS类（控制颜色）
  getStatusCircleClass(statusCode) {
    // statusCode 可能为: 数字0,1,2 或 空字符串'' 或 null/undefined
    if (statusCode === '' || statusCode === null || statusCode === undefined) {
      return 'status-gray'; // 空/无数据 -> 灰色
    }
    // 确保转换为数字进行比较
    const code = Number(statusCode);
    switch (code) {
      case 0:
        return 'status-red';   // 0 -> 红色
      case 1:
        return 'status-green'; // 1 -> 绿色
      case 2:
        return 'status-blue';  // 2 -> 蓝色
      case 3:
        return 'status-orange';  // 2 -> 蓝色
      case 4:
        return 'status-gray';  // 4 -> 灰色
      default:
        return 'status-gray';  // 其他未知值 -> 灰色
    }
  },

  /** 获取 tag 文本 */
  getTagText(value, tagConfig) {
    if (!tagConfig) return value;
    // value 可能是 'true'/'false' 字符串或布尔值
    const key = String(value);
    const cfg = tagConfig[key];
    return cfg ? cfg.text : value;
  },

  /** 获取 tag 类型（颜色） */
  getTagType(value, tagConfig) {
    if (!tagConfig) return '';
    const key = String(value);
    const cfg = tagConfig[key];
    return cfg ? cfg.type : '';
  },

  // 处理图标点击事件（可选）
  handleIconClick(row, columnItem) {
    this.$emit('icon-click', {
      row,
      column: columnItem,
      statusCode: row[columnItem.prop],
      tooltipValue: row[columnItem.column.tooltipField]
    });
  },

  // 处理 tag 点击事件（column.clickable 为 true 时启用）
  handleTagClick(row, columnItem) {
    this.$emit('tag-click', row, columnItem);
  },

  handleSizeChanges(val) {
    this.$emit('sizeChange', val);
  },
  handleCurrentChanges(val) {
    this.$emit('currentChange', val);
  },
  rowClick(row) {
    this.$emit('rowClick', row);
  },
  handleSelectionChange(rows) {
    this.$emit('selection-change', rows);
  },
  clearSelection() {
    if (this.$refs.refTable) {
      this.$refs.refTable.clearSelection();
    }
  },

  /** ✅ 供父组件调用的公共方法：展开 / 收起某一行
      （父组件点链接就能控制展开，不必去摸组件内部的 $refs 路径；
       调用后 Element 同样会触发 expand-change，由上面的 expandChange 同步 expands） */
  toggleRowExpansion(row, expanded) {
    if (this.$refs.refTable) {
      this.$refs.refTable.toggleRowExpansion(row, expanded);
    }
  },
  expandChange(row, expandedRows) {
    this.$emit('expandChange', row);
    let that = this

    /* ✅ 多行可同时展开（默认关闭 = 维持原来「一次只开一行」的行为，其它页面不受影响）。
       直接用 Element 给的 expandedRows（它就是当前所有展开行的全量列表）反推 key，
       比自己维护「点开就 push / 收起就 splice」更稳，不会出现两边不同步。 */
    if (this.expandMultiple) {
      that.expands = Array.isArray(expandedRows)
        ? expandedRows.map((r) => (this.rowKey ? r[this.rowKey] : r.id))
        : [];
      return;
    }

    if (expandedRows.length) {
      that.expands = []
      if (row) {
        // ✅ 传了 rowKey 就按该字段取行标识（与 el-table 的 row-key 对应），否则维持原来的 row.id
        that.expands.push(this.rowKey ? row[this.rowKey] : row.id)
      }
    } else {
      that.expands = []// 默认不展开
    }
    // console.log('that.expands', that.expands)
  },
dealProgress(num) {
if (num === null || num === undefined || num === '') return 0;
const n = Number(num);

// ✅ 只对数值做截断，不四舍五入
return Math.floor(n * 10000) / 10000;
},
  handleClick(row, fnName) {
    this.$emit(`${fnName}`, row);
  },
  getIcon(data) {
    return data;
  }
}
};
</script>

<style scoped lang="scss">

/* ✅ 表格圆角：表格圆角修改参数，全站 card-table 统一用它，想改大小只动这一个变量 */
$table-radius: 6px;

.tag-clickable {
  cursor: pointer;
}

.card-table {
  height: 100%;
  font-family: "Microsoft YaHei", 微软雅黑, sans-serif; /* 添加字体族 */
  font-size: 10px; /* 添加基础字号 */
	overflow: hidden;

}
.iconBlue {
  color: #2678ff;
  font-size: 10px;
  font-weight: 600;
}
.iconNormal {
  color: #808080;
  font-size: 20px;
  font-weight: 600;
}

/* 使用深度选择器覆盖 Element Table 内部元素的字体 + 表格整体圆角（$table-radius） */
.card-table ::v-deep .el-table {
  font-family: "Microsoft YaHei", 微软雅黑, sans-serif;
  font-size: 10px;
  /* 表格整体圆角：overflow:hidden 会把里面的表头 / 表体裁出圆角 */
  border-radius: $table-radius;
  overflow: hidden;
}
/* 表头：上圆角 */
.card-table ::v-deep .el-table__header-wrapper,
.card-table ::v-deep .el-table__fixed-header-wrapper {
  border-radius: $table-radius $table-radius 0 0;
  overflow: hidden;
}
/* 表体：下圆角（内容多、内部滚动也不会漏出来） */
.card-table ::v-deep .el-table__body-wrapper,
.card-table ::v-deep .el-table__fixed-body-wrapper {
  border-radius: 0 0 $table-radius $table-radius;
}
/* 空数据占位块 */
.card-table ::v-deep .el-table__empty-block {
  border-radius: 0 0 $table-radius $table-radius;
}
/* 固定列区域整体跟着圆（它们是 absolute 定位、盖在最上层） */
.card-table ::v-deep .el-table__fixed,
.card-table ::v-deep .el-table__fixed-right {
  border-radius: $table-radius;
  overflow: hidden;
}
/* 表头首/末格、表体最后一行首/末格：把背景色也裁成圆的（悬停 / 选中行同样适用） */
.card-table ::v-deep .el-table__header th:first-child,
.card-table ::v-deep .el-table__fixed-header-wrapper th:first-child {
  border-top-left-radius: $table-radius;
}
.card-table ::v-deep .el-table__header th:last-child,
.card-table ::v-deep .el-table__fixed-header-wrapper th:last-child {
  border-top-right-radius: $table-radius;
}
.card-table ::v-deep .el-table__body tr:last-child td:first-child,
.card-table ::v-deep .el-table__fixed-body-wrapper tr:last-child td:first-child {
  border-bottom-left-radius: $table-radius;
}
.card-table ::v-deep .el-table__body tr:last-child td:last-child,
.card-table ::v-deep .el-table__fixed-body-wrapper tr:last-child td:last-child {
  border-bottom-right-radius: $table-radius;
}
/* 新增样式：为表头行添加背景色 */
.card-table ::v-deep .el-table__header thead th {
  background-color: rgba(37, 100, 207, 0.06) !important;
  user-select: text !important;
}
// /* 新增核心样式：修改表头单元格 (th) 的内边距 (padding) */
// .card-table ::v-deep .el-table th {
//   padding: 10px 0 !important; /* 上下为2px，左右为0。可按需调整左右值，如 padding: 5px; */
// }

// /* 新增核心样式：影响所有表格行高的原因！！修改表格主体单元格 (td) 的内边距 (padding) */
// .card-table ::v-deep .el-table td {
//   padding: 10px 0 !important; /* 上下为5px，左右为0。可按需调整左右值，如 padding: 5px; */
// }

/* 覆盖表头字体，确保加粗效果也使用指定字体 */
.card-table ::v-deep .el-table__header th .cell {
  font-family: "Microsoft YaHei", 微软雅黑, sans-serif;
  font-size: 12px;
  font-weight: bold; /* 通常表头是加粗的，这里明确一下 */
  // align-items: center !important; 

}
/* 覆盖表格主体单元格字体 */
.card-table ::v-deep .el-table__body td .cell {
  font-family: "Microsoft YaHei", 微软雅黑, sans-serif;
  font-size: 12px;
}
/* 覆盖分页组件的字体（如果分页组件也在此文件样式作用域内） */
.card-table ::v-deep .el-pagination {
  font-family: "Microsoft YaHei", 微软雅黑, sans-serif;
}

/* 覆盖 Element UI 表格排序图标的大小 */
.card-table ::v-deep .el-table .caret-wrapper {
  height: 34px !important; /* 调整整个图标容器的高度，默认值可能为14px */
}

/* 实心圆基础样式 */
.status-circle-base {
  width: 16px;
  height: 16px;
  border-radius: 50%; /* 圆形 */
  display: inline-block;
  margin: 0 auto;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;
}
.status-circle-base:hover {
  transform: scale(1.2);
  opacity: 0.9;
}

/* 状态颜色类 */
.status-gray {
  background-color: #c0c4cc; /* 灰色 - 空/无数据 */
  box-shadow: 0 0 3px rgba(192, 196, 204, 0.5);
}
.status-red {
  background-color: #f56c6c; /* 红色 - 状态0 */
  box-shadow: 0 0 3px rgba(245, 108, 108, 0.5);
}
.status-green {
  background-color: #67c23a; /* 绿色 - 状态1 */
  box-shadow: 0 0 3px rgba(103, 194, 58, 0.5);
}
.status-blue {
  background-color: #2564CFCC; /* 蓝色 - 状态2 */
  box-shadow: 0 0 3px rgba(64, 158, 255, 0.5);
}
.status-orange {
  background-color: #e29f3b; /* 蓝色 - 状态2 */
  box-shadow: 0 0 3px #e29f3bCC;
}


/* 链接样式 */
.custom-link:hover {
  opacity: 0.8;
  text-decoration: underline;
}
.custom-link:active {
  opacity: 0.6;
}
/* ✅ 链接列的行级禁用态（如「物料属性=外购」）：普通字体 + 默认光标，
   悬浮 / 按下都不加下划线、不变透明度，看上去就是一段普通文本
   ⚠️ 必须写在顶层且带 :hover / :active —— 否则会被上面 .custom-link:hover 的
      text-decoration: underline 盖回去（禁用态当初误放进 @media 块里，电脑端就没生效） */
.custom-link.is-disabled,
.custom-link.is-disabled:hover,
.custom-link.is-disabled:active {
  color: #606266;
  cursor: default;
  text-decoration: none;
  opacity: 1;
  font-weight: normal;
}

/* 评审进度暂存链接样式 */
.review-link {
  color: #2564CFCC;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  font-weight: normal;
}
.review-link:hover {
  opacity: 0.8;
  text-decoration: underline;
}



/* 编辑容器样式 */
.edit-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 24px;
}



/* 文本显示样式 */
.text-display {
  color: #606266;
  font-size: 12px;
  word-break: break-word;
  max-width: 150px;
  display: -webkit-box;
  // -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

/* 编辑按钮样式 */
.edit-btn {
  // padding: 2px;
  font-size: 12px;
  color: #2564CFCC;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}
.edit-btn:hover {
  opacity: 1;
  color: #66b1ff;
}

/* 日期显示样式 */
.date-display {
  color: #606266;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
  display: inline-block;
  vertical-align: middle;
}

/* 重置密码按钮样式 */
.reset-password-btn {
  color: #2564CFCC; /* 橙色，表示警告/操作 */
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 3px;
  transition: all 0.3s ease;
  border: 1px solid #2564CFCC;
  background-color: transparent;
}
.reset-password-btn:hover {
  color: #fff;
  background-color: #2564CFCC;
  border-color: #2564CFCC;
}
.reset-password-btn:active {
  color: #fff;
  background-color: #2564CFCC;
  border-color: #2564CFCC;
}

/* ================= 可复制单元格 ================= */
/* ✅ 普通文本列：稳定 hover */
.copy-cell {
  display: inline-block;        /* ✅ 关键 */
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: text;
  padding: 2px 0;              /* ✅ 增大 hover 区域 */
  line-height: 1.2;
}

/* ✅ tooltip 本身允许选中 */
.card-table ::v-deep .copy-tooltip-long {
  user-select: text !important;
  max-width: 400px !important;
  pointer-events: auto !important;   /* ✅ 关键 */
}

/* ✅ tooltip 本身允许选中 */
.card-table ::v-deep .copy-tooltip-long {
  user-select: text !important;
  max-width: 400px !important; /* ✅ 防止太窄 */
}
/* tooltip 本身允许选中 */
.card-table ::v-deep .el-tooltip__popper {
  user-select: text !important;
}

/* 隐藏排序图标 */
.card-table ::v-deep .el-table .caret-wrapper {
  display: none !important;
}

  .progress-cell {


    /* 进度条内部填充 */
    ::v-deep .el-progress-bar__inner {
      border-radius: 4px !important;
    }

    /* 百分比文字大小 */
    ::v-deep .el-progress__text {
      font-size: 12px !important;  /* 默认 14px → 10px */
      line-height: 1 !important;
      // margin-left: 4px !important;
    }
  }
/* ✅ 表格内容比较分散 表格内容 padding（抗 pageSize 变化） */
.card-table ::v-deep .el-table__body td {
  padding: 0 !important;
}

.card-table ::v-deep .el-table__body td .cell {
  padding: 8px 2px 8px 1px !important;
  line-height: 1.2;
}

/* ✅ 固定列同步同样的 padding，防止滚动时固定列偏移 */
.card-table ::v-deep .el-table__fixed-body-wrapper .el-table__body td {
  padding: 0 !important;
}
.card-table ::v-deep .el-table__fixed-body-wrapper .el-table__body td .cell {
  padding: 8px 2px 8px 1px !important;
  line-height: 1.2;
}

/* ========== 固定列对齐终极修复 ========== */
/* 1. 固定列表头样式与普通表头完全一致 */
.card-table ::v-deep .el-table__fixed-header-wrapper .el-table__header th {
  padding: 0 !important;
}
.card-table ::v-deep .el-table__fixed-header-wrapper .el-table__header th .cell {
  padding: 4px 2px !important;
  font-family: "Microsoft YaHei", 微软雅黑, sans-serif;
  font-size: 12px;
  font-weight: bold;
}

/* 2. 所有表头 th 统一高度，确保有/无 popover 的列高度一致 */
.card-table ::v-deep .el-table__header-wrapper thead th,
.card-table ::v-deep .el-table__fixed-header-wrapper thead th {
  height: 36px !important;
  line-height: 1.2;
  padding: 0 !important;
}

/* 3. 所有表头 .cell 统一 padding */
.card-table ::v-deep .el-table__header-wrapper .el-table__header th .cell,
.card-table ::v-deep .el-table__fixed-header-wrapper .el-table__header th .cell {
  padding: 4px 2px !important;
  font-family: "Microsoft YaHei", 微软雅黑, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.2;
  display: flex;
  align-items: center;
  height: 100%;
}

/* 4. 统一固定列表头的背景色 */
.card-table ::v-deep .el-table__fixed-header-wrapper thead th {
  background-color: rgba(37, 100, 207, 0.06) !important;
}



/* ================= 手机端表格优化 ================= */
@media screen and (max-width: 768px) {

  /* 表头 + 表体 单元格统一压缩 */
  .card-table ::v-deep .el-table .el-table__cell {
    //padding: 8px 0 !important;

  }
  /* 覆盖表格主体单元格字体 */
  .card-table ::v-deep .el-table__body td .cell {
    font-family: "Microsoft YaHei", 微软雅黑, sans-serif;
    font-size: 10px;
  }
  /* 表头更紧凑 */
  .card-table ::v-deep .el-table th {
    padding: 4px 0 !important;
    font-size: 10px !important;
  }

  .card-table ::v-deep .el-table__header thead th {
    background-color: rgba(37, 100, 207, 0.08) !important;
  }

  /* 覆盖表头字体，确保加粗效果也使用指定字体 */
  .card-table ::v-deep .el-table__header th .cell {
    font-family: "Microsoft YaHei", 微软雅黑, sans-serif;
    font-size: 10px;
    font-weight: bold; /* 通常表头是加粗的，这里明确一下 */
    // align-items: center !important; 

  }

  /* ✅ 表头字体真正生效的 10px：
     上面（手机端之外）还有两条权重更高的规则把表头写成了 12px：
       .el-table__header-wrapper .el-table__header th .cell
       .el-table__fixed-header-wrapper .el-table__header th .cell
     媒体查询本身不增加权重，所以这里必须把选择器写全（甚至更长）才能压过它们。 */
  .card-table ::v-deep .el-table__header-wrapper .el-table__header th .cell,
  .card-table ::v-deep .el-table__fixed-header-wrapper .el-table__header th .cell {
    font-family: "Microsoft YaHei", 微软雅黑, sans-serif !important;
    font-size: 10px !important;
    font-weight: bold;
    padding: 3px 2px !important;
    line-height: 1.1 !important;
  }

  /* 表头里的自定义文字 / 排序图标 / 漏斗图标跟着一起缩小 */
  .card-table ::v-deep .el-table__header-wrapper .el-table__header th,
  .card-table ::v-deep .el-table__fixed-header-wrapper .el-table__header th {
    font-size: 10px !important;
    height: 30px !important;
  }
  /* 表体行高 & padding 压缩 */
  .card-table ::v-deep .el-table td {
    // padding: 4px 0 !important;
    font-size: 10px !important;
    // line-height: 1.2 !important;
  }

  /* 单元格内容更紧 */
  .card-table ::v-deep .el-table .cell {
    line-height: 1 !important;
    padding-left: 4px !important;
    padding-right: 4px !important;
    // padding-top: 4px !important;
    // padding-bottom: 4px !important;
  }

  /* 排序图标缩小 */
  .card-table ::v-deep .el-table .caret-wrapper {
    display:none;
  }

  .card-table ::v-deep .el-table__body .el-button--text {
    padding: 0 4px !important;
    height: 20px !important;
    line-height: 20px !important;
    font-size: 11px !important;
  }

    /* ========== 进度条手机适配（新增） ========== */
  .progress-cell {
    /* 缩小进度条整体高度 */
    ::v-deep .el-progress {
      line-height: 1 !important;
    }

    /* 进度条轨道高度 */
    ::v-deep .el-progress-bar__outer {
      height: 6px !important;  /* 默认 14px → 8px */
      width: 40px !important;  /* 默认 14px → 8px */
      border-radius: 4px !important;
    }

    /* 进度条内部填充 */
    ::v-deep .el-progress-bar__inner {
      border-radius: 4px !important;
    }

    /* 百分比文字大小 */
    ::v-deep .el-progress__text {
      font-size: 10px !important;  /* 默认 14px → 10px */
      line-height: 1 !important;
      margin-left: 4px !important;
    }
  }

  // /* 操作按钮变小 */
  // .card-table ::v-deep .el-button--text {
  //   // font-size: 12px !important;
  //   // padding: 0 4px !important;
  // }

  // /* 链接字体 */
  // .custom-link {
  //   // font-size: 14px !important;
  // }

  /* 状态圆点缩小 */
  .status-circle-base {
    width: 12px !important;
    height: 12px !important;
  }

  /* 编辑按钮 */
  .edit-btn {
    font-size: 12px !important;
  }

  /* 日期 / 文本显示 */
  .date-display,
  .text-display {
    font-size: 12px !important;
  }

  /* 分页整体缩小 */
  .card-table ::v-deep .el-pagination {
    font-size: 12px !important;
    padding: 4px 0 !important;
  }

  /* 缩小日期选择器整体 */
  ::v-deep .el-date-range-picker {
    width: 320px !important;
    transform: scale(0.9);
    transform-origin: top center;
  }

  /* 输入框高度缩小 */
  ::v-deep .el-date-range-picker .el-input__inner {
    height: 28px !important;
    font-size: 12px !important;
  }

  /* 日历单元格缩小 */
  ::v-deep .el-date-range-picker .el-date-table td {
    padding: 2px !important;
  }

  /* 按钮缩小 */
  ::v-deep .el-date-range-picker .el-button {
    padding: 6px 10px !important;
    font-size: 12px !important;
  }

}

/* ================= 列拖拽排序样式 ================= */
/* 启用拖拽时，表头显示抓手光标 */
.column-draggable ::v-deep .el-table__header-wrapper th {
  cursor: grab !important;
}
.column-draggable ::v-deep .el-table__header-wrapper th:active {
  cursor: grabbing !important;
}
/* 拖拽虚影 */
.column-drag-ghost {
  opacity: 0.45;
  background: #a0c4f0 !important;
}
/* 被拖拽的原始列 */
.column-drag-chosen {
  opacity: 0.5;
  background: #dce8f5 !important;
}

/* ================= 列宽拖拽调整样式 ================= */
/* 表头每列右边加分隔竖线（可拖拽调节列宽） */
.column-resizable ::v-deep .el-table__header-wrapper th {
  position: relative;
  border-right: 1px solid #dcdfe6;
}
/* 拖拽手柄 */
::v-deep .column-resize-handle {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 6px;
  cursor: col-resize;
  z-index: 10;
  user-select: none;
  background-color: transparent;
  transition: background-color 0.2s;
}
::v-deep .column-resize-handle:hover,
::v-deep .column-resize-handle:active {
  background-color: rgba(64, 158, 255, 0.3);
}

</style>
